import React, { useState, useEffect, useRef } from "react";
import { Form, Grid, Card, Table, Button, Icon, Dimmer, Alert } from "tabler-react";

import SplitterLayout from 'react-splitter-layout';
import 'react-splitter-layout/lib/index.css';
import SiteWrapper from "../../../SiteWrapper.react";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";
import * as ACTIONS from '../../../store/actions/actions'
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import Modal from 'react-modal';
import '../../navBarItems/MonitoreoPage.react.css';
import Crud_Catalogos from "../../../herramientas/Crud_Catalogos";
import ModalLay from "../../../components/ModalLay/ModalLay";
import { TransportistasForm } from "../../../Catalogos";
import LoadStore from "../../../store/LoadStore";
import { timeToDateFill } from "../../../herramientas/DateFormat";
import { esFecha } from "../../../herramientas/Forms";
import { validarGuardado } from "./validarGuardado";
import Cliente from "../Cliente";
import Transportista from "../Transportista";
import { TablePageable } from "../../../Helpers";
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import './MovimientosNavierosCliente.css';
import EntregasNavierasForm from "./EntregaNavierasForm";
import { PersonasForm } from "../../../Catalogos";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import ModalCancelacionServicio from "../../../components/ModalCancelacionServicio";
import ModalMovimientoPatio from "./ModalMovimientoPatio";
import ModalDestino from "./ModalDestino";
import Axios from "axios";
import { api_raiz } from "../../../config/config";
import ClienteForm from "../../../Catalogos/Cliente";
import CargaMasivaSolicitudes from "./CargaMasivaSolicitudes";

const user = JSON.parse(sessionStorage.getItem("usuario"));

// // Agregar estilos globales para manejar z-index de modales
const modalStyles = `
  .react-confirm-alert-overlay {
    z-index: 9999 !important;
    background-color: rgba(0, 0, 0, 0.7) !important;
  }
  .react-confirm-alert {
    z-index: 10000 !important;
  }
  .ReactModal__Overlay {
    z-index: 1000 !important;
  }
  .Modal {
    z-index: 1001 !important;
  }
`;

// Inyectar estilos si no existen
if (!document.getElementById('modal-z-index-styles')) {
  const style = document.createElement('style');
  style.id = 'modal-z-index-styles';
  style.textContent = modalStyles;
  document.head.appendChild(style);
}

let guardando = false;
let MovimientosObject = {};
let estatusOperacion = [];
let estatusRutas = [];
let usuariosLogObject = {
  idBitacoraMonitoreo: 0,
  idUsuario: 0,
  idMovimiento: 0,
  accionFecha: "",
  descripcion: "",
  idPlataformaTipo: 1,
};

const technologiaOpciones = [
  { label: "4G Lite", value: "4G Lite" },
  { label: "5G", value: "5G" }
]

const colocacionDesechableOpciones = [
  { label: "Dentro de la caja", value: "Dentro de la caja" },
  { label: "Dentro de la carga", value: "Dentro de la carga" },
  { label: "Fuera de la caja/contenedor", value: "Fuera de la caja/contenedor" }
]

const colocaOpciones = [
  { label: "Coloca cliente", value: "Coloca cliente" },
  { label: "Coloca Sky", value: "Coloca Sky" }
]

const MovimientosNavierosClientePage = (
  { privilegios_object, stor
  }
) => {
  const guardando = useRef(false);
  const [solicitudes, setSolicitudes] = useState([]);

  const [plataformas, setPlataformas] = useState([]);
  const [gpsTipoColocaciones, setGpsTipoColocaciones] = useState([]);
  const [corredores, setCorredores] = useState([]);
  const [localidades, setLocalidades] = useState([]);
  const [localidadesMT, setLocalidadesMT] = useState([]);
  const [clientesNavieros, setClientesNavieros] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [movimientosTipo, setMovimientosTipo] = useState([]);
  const [operacionTipos, setOperacionTipos] = useState([]);
  const [transportistas, setTransportistas] = useState([]);
  const [contenedoresTipo, setContenedoresTipo] = useState([]);
  const [ejecutivos, setEjecutivos] = useState([]);
  const [remolquesTipo, setRemolquesTipo] = useState([]);
  const [noContenedores, setNoContenedores] = useState(1);
  const [noPo, setNoPo] = useState(1);
  const [referenciaFacturacion, setReferenciaFacturacion] = useState([]);
  const [paisSeleccionado, setPaisSeleccionado] = useState({ value: "mx", label: "MX" });
  const [paisLocalidad, setPaisLocalidad] = useState({ value: "MX", label: "MX" });

  const [idPlataforma, setIdPlataforma] = useState({ value: 0, label: "Selecciona una plataforma" });
  const [gpsTipoColocacion, setGpsTipoColocacion] = useState({ value: 0, label: "Selecciona una opción" });
  const [idCorredor, setIdCorredor] = useState({ value: 0, label: "No se ha seleccionado plataforma" });
  const [localidad, setLocalidad] = useState({ value: 0, label: "No se ha seleccionado plataforma" });
  const [localidadMT, setlocalidadMT] = useState({ value: 0, label: "No se ha seleccionado plataforma" });
  const [idClienteNaviero, setIdClienteNaviero] = useState({ value: 0, label: "No se ha seleccionado plataforma" });
  const [idCliente, setIdCliente] = useState({ value: 0, label: "No se ha seleccionado plataforma" });
  const [idMovimientoTipo, setIdMovimientoTipo] = useState({ value: 0, label: "No se ha seleccionado plataforma" });
  const [idOperacionTipo, setIdOperacionTipo] = useState({ value: 0, label: "No se ha seleccionado plataforma" });
  const [idTransportista, setIdTransportista] = useState({ value: 0, label: "No se ha seleccionado plataforma" });
  const [contenedorTipo, setContenedorTipo] = useState({ value: 0, label: "Selecciona el tipo de carga", data: [], });
  const [contenedorSize, setContenedorSize] = useState({ value: 0, label: "Selecciona el tamaño" });
  const [ejecutivo, setEjecutivo] = useState("");
  const [contenedor, setContenedor] = useState([]);
  const [po, setPo] = useState([]);
  const [booking, setBooking] = useState([]);
  const [citaProgramada, setCitaProgramada] = useState("");
  const [citaProgramadaTerminal, setCitaProgramadaTerminal] = useState("");
  const [citaColocacionGps, setCitaColocacionGps] = useState("");
  const [destino, setDestino] = useState("");
  const [nota, setNota] = useState("");
  const [variablesObj, setVariablesObj] = useState({});
  const [variables, setVariables] = useState([]);
  const [entregasCarga, setEntregasCarga] = useState([]);
  const [entregasDesCarga, setEntregasDesCarga] = useState([]);

  const [unMovimientoPorContenedor, setUnMovimientoPorContenedor] = useState(true);//Se genera un movimiento por cada contenedor ingresado
  const [currentMovimiento, setCurrentMovimiento] = useState({});

  const [modalidadSeleccionada, setModalidadSeleccionada] = useState();
  const [modalidades, setModalidades] = useState([]);
  const [modalidadesSeleccionadas, setModalidadesSeleccionadas] = useState([]); 
  const [sinCobertura, setSinCobertura] = useState(false);
  const [tecnologia, setTecnologia] = useState();
  const [colocacionDesechable, setColocacionDesechable] = useState();
  const [coloca, setColoca] = useState();
  const [ov, setOv] = useState("");
  // const [codigoPostal, setCodigoPostal] = useState();

  const [hiddenPanel, setHiddenPanel] = useState(false);
  const [hiddenModals, setHiddenModals] = useState(false);
  const [crudbutonEnable, setCrudbutonEnable] = useState(true); // Se desabilita cuando se hace click en guardar
  const [nuevo, setNuevo] = useState(true);

  //varibles para destino
  const [estado, setEstado] = useState("");
  const [municipio, setMunicipio] = useState("");
  const [colonia, setColonia] = useState("");
  const [calle, setCalle] = useState("");
  const [numero, setNumero] = useState("");
  const [cp, setCP] = useState("");
  //Variables para Datos de la unidad 
  const [modelot, setModelot] = useState("");
  const [marcat, setMarcat] = useState("");
  const [colort, setColort] = useState("");
  const [placat, setPlacat] = useState("");
  const [economicot, setEconomicot] = useState("");
  const [placar, setPlacar] = useState("");
  const [economicor, setEconomicor] = useState("");
  const [observaciones, setObservaciones] = useState("");

  //Variables para Operador
  const [nombreOperador, setNombreOperador] = useState("");
  const [medioContacto, setMedioContacto] = useState("");
  const [licencia, setLicencia] = useState("");

  // Estados para contactos
  const [contactoMonitoreo1, setContactoMonitoreo1] = useState('');
  const [contactoMonitoreo2, setContactoMonitoreo2] = useState('');
  const [contactoMonitoreo3, setContactoMonitoreo3] = useState('');
  const [contactoLineaColocacion1, setContactoLineaColocacion1] = useState('');
  const [contactoLineaColocacion2, setContactoLineaColocacion2] = useState('');
  const [contactoLineaColocacion3, setContactoLineaColocacion3] = useState('');

  // Estado para el checkbox
  const [isChecked, setIsChecked] = useState(false);

  // Estado para razón social a facturar
  const [razonSocialFacturar, setRazonSocialFacturar] = useState("");

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

 

  useEffect(() => {
    // Solo concatenar si idPlataforma es 4
    if (idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value)) {
      // Concatenar los campos de dirección
      const destinoCom = `${estado}, ${municipio}, ${colonia}, ${calle}, ${numero}, ${cp}`;
      setDestino(destinoCom)
    } else {
      setDestino(""); // Limpiar el destino si idPlataforma no es 4
    }
  }, [estado, municipio, colonia, calle, numero, cp]);

  // Estado para manejar los contactos
  const [contactos, setContactos] = useState([]);
  const obtenerContactos = async () => {
    try {
      const response = await Axios.get(
        `${api_raiz}personas/cliente/${idCliente.value}`
      );
      setContactos(response.data);  // Guarda los contactos en el estado
    } catch (error) {
      console.error("Error al obtener contactos:", error);
    }
  };

  // Estados para el modal de cancelación
  const [modalCancelacionOpen, setModalCancelacionOpen] = useState(false);
  const [servicioACancelar, setServicioACancelar] = useState(null);
  const [tieneGPS, setTieneGPS] = useState(false);
  const [cargandoGPS, setCargandoGPS] = useState(false);
  const [procesandoCancelacion, setProcesandoCancelacion] = useState(false);

  const deletedPersona = async (personaT) => {
    try {
      // Realizar las operaciones de eliminación
      await Promise.all([
        Axios.post(
          `${api_raiz}contacto/${idCliente.value}/Borrar`,
          {},
          { params: { mail: personaT.correo } }
        ).catch(error => {
          console.warn("Error al eliminar contacto (puede no existir):", error);
          return { data: "ok" }; // Continuar aunque falle
        }),
        Axios.delete(
          `${api_raiz}clientesContactos/borrar/${idCliente.value}/${personaT.id}`
        ).catch(error => {
          console.warn("Error al eliminar relación cliente-contacto:", error);
          return { data: "ok" }; // Continuar aunque falle
        }),
        Axios.delete(`${api_raiz}personas/${personaT.id}`)
      ]);
      
      // Mostrar notificación de éxito
      NotificationManager.success(
        `Contacto ${personaT.nombre} ${personaT.aPaterno} eliminado correctamente`,
        "Eliminado"
      );
      
      // Actualizar la lista de contactos después de eliminar
      await obtenerContactos();
      
      // Cerrar el modal automáticamente después de un pequeño delay
      setTimeout(() => {
        setHiddenModals(true);
      }, 500);
      
    } catch (error) {
      console.error("Error al eliminar persona:", error);
      NotificationManager.error(
        "Error al eliminar el contacto. Por favor, inténtelo de nuevo.",
        "Error"
      );
    }
  };

  // Función para consultar si el movimiento tiene GPS
  const consultarGPSMovimiento = async (solicitud) => {
    setCargandoGPS(true);
    try {
      const response = await Axios.get(
        `${api_raiz}movimientoGps/movimiento/${solicitud.idMovimiento}`
      );
      
      // Verificar si tiene GPS asignado y que el id del GPS sea >= 20
      const tieneGPSAsignado = response.data && response.data.length > 0 && 
                               response.data.some(gps => gps.gps && gps.gps.id >= 21);
      
      setTieneGPS(tieneGPSAsignado);
      setServicioACancelar(solicitud);
      setModalCancelacionOpen(true);
      
    } catch (error) {
      console.error("Error al consultar GPS del movimiento:", error);
      NotificationManager.error(
        "Error al consultar el estado del GPS. Inténtelo de nuevo.",
        "Error"
      );
    } finally {
      setCargandoGPS(false);
    }
  };

  // Función para cancelar el servicio
  const cancelarServicio = async () => {
    setProcesandoCancelacion(true);
    try {
      if (tieneGPS) {
        // Si tiene GPS: cambiar operación a 3 y GPS a 3
        await Axios.put(
          `${api_raiz}navieraMovimientos/movimiento/${servicioACancelar.idMovimiento}/operacionestatus/3`
        );
        await Axios.post(
          `${api_raiz}mail/arrobanaviera/${servicioACancelar.idMovimiento}/28?nota=null`
        );

        NotificationManager.success(
          `Servicio ${servicioACancelar.idSolicitud} cancelado correctamente (Se aplicará cargo por GPS asignado)`,
          "Servicio Cancelado"
        );
      } else {
        // Si NO tiene GPS: cambiar operación a 4
        await Axios.put(
          `${api_raiz}navieraMovimientos/movimiento/${servicioACancelar.idMovimiento}/operacionestatus/4`
        );
        await Axios.post(
          `${api_raiz}mail/arrobanaviera/${servicioACancelar.idMovimiento}/27?nota=null`
        );
        
        NotificationManager.success(
          `Servicio ${servicioACancelar.idSolicitud} cancelado correctamente`,
          "Servicio Cancelado"
        );
      }
      
      // Actualizar estado local
      const solicitudesActualizadas = solicitudes.map(sol => {
        if (sol.idSolicitud === servicioACancelar.idSolicitud) {
          return { ...sol, cancelado: true };
        }
        return sol;
      });
      setSolicitudes(solicitudesActualizadas);
      
      // Cerrar modal
      setModalCancelacionOpen(false);
      setServicioACancelar(null);
      setTieneGPS(false);
      
      // Recargar solicitudes para actualizar la lista automáticamente
      getSolicitudes();
      
    } catch (error) {
      console.error("Error al cancelar servicio:", error);
      NotificationManager.error(
        "Error al cancelar el servicio. Inténtelo de nuevo.",
        "Error"
      );
    } finally {
      setProcesandoCancelacion(false);
    }
  };

  useEffect(() => {
    obtenerContactos();
  }, [idCliente]); // Se ejecuta cuando `currentMovimiento` cambia


  //Encapsulamiento de la logica de recarga inicial
  const initializeData = () => {
    getfuntion("get", "", "", "contenedorTipo", "contenedorTipo");
    getfuntion("get", "", "", "remolquesTipo", "remolquesTipo");
    getfuntion("get", "", "", "plataformas/usuario/" + user.id + "/bloque/564", "plataformas");//564 bloque movimientos_nav_clien
    //Obtener catalogo de modalidad de transporte
    getfuntion("get", "", "", "modalidades-transporte", "modalidad");
    getSolicitudes();
  };

  // Función para debuggear variables específicas usando Object.fromEntries
  const debugVariablesEspecificas = () => {
    const variablesDeseadas = [
      'referencia_facturacion',
      'modalidad',
      'ejecutivo',
      'referencia_chubb',
      'nombre_aseguradora',
      'Ejecutivo',
      'cita_colocacion',

    ];
    const variablesFiltradas = Object.fromEntries(
      Object.entries(variablesObj).filter(([key]) => variablesDeseadas.includes(key))
    );
    return variablesFiltradas;
  };

  // Función para filtrar las variables que se muestran en el formulario
  const getVariablesFiltradas = () => {
    const variablesDeseadas = [
      'modalidad',
      'ejecutivo',
      'referencia_chubb',
      'nombre_aseguradora',
      'cita_colocacion',
      'cuenta_espejo',
    ];

    return variables.filter(variable => variablesDeseadas.includes(variable.nombre));
  };

  useEffect(() => {
    initializeData();
  }, []);

  useEffect(() => {
    if (idPlataforma.value) {
      if (nuevo) {
        //limpiamos el objeto movimiento
        MovimientosObject = {
          idPlataforma: plataformas.length === 1 ? idPlataforma.data : {},//requerido
          idNaviera: { id: "1", nombre: "Sin naviera" },//Default
          idOperacionTipo: [4, 61, 1381, 1480].includes(idPlataforma.value) && idOperacionTipo.data ? idOperacionTipo.data : {},//requerido
          idMovimientoTipo: {},//requerido
          idTransportista: null,//opcional
          idCliente: null,//opcional
          idClienteNaviero: null,//opcional
          idCorredor: {},//requerido
          idLocalidad: null,//opcional transmodal
          destino: "",//opcional
          estado: "",//requerido
          municipio: "",//requerido
          colonia: "",//requerido
          calle: "",//requerido
          numero: "",//requerido
          cp: "",//requerido 
          modelot: "",//requerido
          marcat: "",//requerido
          colort: "",//requerido
          placat: "",//requerido
          economicot: "",//requerido
          modelor: "",//requerido
          economicor: "",//requerido
          observaciones: "",//opcional
          nombreOperador: "",//requerido
          medioContacto: "",//requerido
          licencia: "",//opcional
          contenedor: "",//requerido
          contenedorTipo: 1,
          contenedorSize: 0,
          booking: "",
          po: "",
          sello: "",
          vip: true,
          nota: "",
          citaProgramada: null,
          citaProgramadaTerminal: null,
          citaColocacionGps: null,
          variables: {
            cuenta_espejo: {
              url: "",
              usuario: "",
              password: ""
            }
          },
          clienteS: null,
          transportistaS: null,
          idLocalidadMT: null,
          contactoMonitoreo1: "",
          contactoMonitoreo2: "",
          contactoMonitoreo3: "",
          contactoLineaColocacion1: "",
          contactoLineaColocacion2: "",
          contactoLineaColocacion3: "",
        };
        setIdMovimientoTipo({ value: 0, label: "Cargando Tipos de movimiento" });
        setIdOperacionTipo({ value: 0, label: "Cargando Tipos de operación" });
        setIdCorredor({ value: 0, label: "Cargando corredores" });
        setLocalidad({ value: 0, label: "Cargando localidades" });
        setlocalidadMT({ value: 0, label: "Cargando localidadesMT" });
        setIdCliente({ value: 0, label: "Cargando Clientes" });
        setIdClienteNaviero({ value: 0, label: "Cargando Clientes Finales" });
        setIdTransportista({ value: 0, label: "Cargando Transportistas" });
        setContenedorSize({ value: 0, label: "Cargando Tipos de remolque" });
        if ([952].includes(idPlataforma.value)) {
          setEjecutivo({ value: 0, label: "Cargando ejecutivos" });
        } else {
          setEjecutivo("");
        }
      } else {
        MovimientosObject.idPlataforma = idPlataforma.data;
        for (let remTipo of remolquesTipo) {
          if (currentMovimiento.contenedorSize === remTipo.value) {
            setContenedorSize(remTipo);
            break;
          }
        }
        for (let contTipo of contenedoresTipo) {
          if (currentMovimiento.contenedorTipo === contTipo.value)
            setContenedorTipo(contTipo);
        }
      }
      if ([952].includes(idPlataforma.value)) {
        setUnMovimientoPorContenedor(false);
      } else {
        setUnMovimientoPorContenedor(true);
      }
      getCatalogosPorPlataforma(idPlataforma.value);
    }
  }, [idPlataforma]);
  useEffect(() => {
    if (currentMovimiento.idSolicitud) {
      /**
       * Cargar catalogos
       */

      const mov = { ...currentMovimiento };
      setNuevo(false);
      if (mov.idPlataforma)//idPlataforma
        setIdPlataforma({ value: mov.idPlataforma.id, label: mov.idPlataforma.nombre, data: mov.idPlataforma, },);
      if (mov.idMovimientoTipo) {//idMovimientoTipo
        setIdMovimientoTipo({ value: mov.idMovimientoTipo.id, label: mov.idMovimientoTipo.nombre, data: mov.idMovimientoTipo },);
        getfuntion("get", "", "", "entregas_navieras/movimiento/" + mov.idMovimiento, "entregas");
      }
      if (mov.idCorredor)//idCorredor
        setIdCorredor({ value: mov.idCorredor.id, label: mov.idCorredor.nombre, },);
      if (mov.idLocalidad)//idLocalidad
        setLocalidad({ value: mov.idLocalidad.id, label: mov.idLocalidad.nombre, },);
      if (mov.idLocalidadMT)//idLocalidadMT
        setlocalidadMT({ value: mov.idLocalidadMT.id, label: mov.idLocalidadMT.nombre, data: mov.idLocalidadMT },);
      if (mov.idTransportista)//idTransportista
        setIdTransportista({ value: mov.idTransportista.id, label: mov.idTransportista.nombre, data: mov.idTransportista },);
      if (mov.idCliente)//idCliente
        setIdCliente({ value: mov.idCliente.id, label: mov.idCliente.nombre, data: mov.idCliente, },);
      if (mov.idClienteNaviero)//idClienteNaviero
        setIdClienteNaviero({ value: mov.idClienteNaviero.id, label: mov.idClienteNaviero.nombre, data: mov.idClienteNaviero, },);
      if (mov.idOperacionTipo)//idOperacionTipo
        setIdOperacionTipo({ value: mov.idOperacionTipo.id, label: mov.idOperacionTipo.nombre, data: mov.idOperacionTipo, },);
      if (mov.idGgpsTipoColocacion)//idGgpsTipoColocacion
        setGpsTipoColocacion({ 
          value: mov.idGgpsTipoColocacion.id, 
          label: [4, 61, 1381, 1480].includes(idPlataforma.value) 
            ? (mov.idGgpsTipoColocacion.nombre === "Respaldo" ? "Doble GPS" : mov.idGgpsTipoColocacion.nombre === "Principal" ? "Principal/Portátil/Recuperable" : mov.idGgpsTipoColocacion.nombre)
            : mov.idGgpsTipoColocacion.nombre, 
          data: mov.idGgpsTipoColocacion, 
        });
      if (idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value)) {
        //Datos de destino
        //`${estado}, ${municipio}, ${colonia}, ${calle}, ${numero}, ${cp}`
        const destinoParts = currentMovimiento.destino.split(",");
        setEstado((destinoParts[0] || "").trim());
        setMunicipio((destinoParts[1] || "").trim());
        setColonia((destinoParts[2] || "").trim());
        setCalle((destinoParts[3] || "").trim());
        setNumero((destinoParts[4] || "").trim());
        setCP((destinoParts[5] || "").trim());
      } else {
        setDestino(mov.destino ? mov.destino : "");
      }
      setNota(mov.nota ? mov.nota : "");
      setModelot(currentMovimiento.modelot ? currentMovimiento.modelot : "");
      setMarcat(currentMovimiento.marcat ? currentMovimiento.marcat : "");
      setColort(currentMovimiento.colort ? currentMovimiento.colort : "");
      setPlacat(currentMovimiento.placat ? currentMovimiento.placat : "");
      setEconomicot(currentMovimiento.economicot ? currentMovimiento.economicot : "");
      setPlacar(currentMovimiento.placar ? currentMovimiento.placar : "");
      setEconomicor(currentMovimiento.economicor ? currentMovimiento.economicor : "");
      setObservaciones(currentMovimiento.observaciones ? currentMovimiento.observaciones : "");
      setNombreOperador(currentMovimiento.nombreOperador ? currentMovimiento.nombreOperador : "");
      setMedioContacto(currentMovimiento.medioContacto ? currentMovimiento.medioContacto : "");
      setLicencia(currentMovimiento.licencia ? currentMovimiento.licencia : "");
      cargarModalidadesSolicitud(mov.idSolicitud);
      setBooking(mov.booking ? mov.booking : "");
      //Contenedor
      let contenedorTemp = [];
      for (let i = 0; i < mov.contenedor.split(";").length; i++) {
        contenedorTemp.push(mov.contenedor.split(";")[i])
      }
      setContenedor(contenedorTemp);
      setNoContenedores(mov.contenedor.split(";").length);
      //referencia_facturacion por contenedor
      if ([4, 61, 1381, 1480].includes(mov.idPlataforma?.id) && mov.variables && mov.variables.referencia_facturacion) {
        setReferenciaFacturacion(mov.variables.referencia_facturacion.split(";"));
      } else {
        setReferenciaFacturacion([]);
      }
      //po
      let poTemp = [];
      if (mov.po) {
        for (let i = 0; i < mov.po.split(";").length; i++) {
          poTemp.push(mov.po.split(";")[i])
        }
      }
      setPo(poTemp);
      setNoPo(mov.po ? mov.po.split(";").length : 1);

      if (mov.citaProgramada != null) {
        setCitaProgramada(new Date(mov.citaProgramada));
      }
      if (mov.citaProgramadaTerminal != null) {
        setCitaProgramadaTerminal(new Date(mov.citaProgramadaTerminal));
      }
      if (mov.citaColocacionGps != null) {
        setCitaColocacionGps(new Date(mov.citaColocacionGps));
      }
      setModalidadSeleccionada(mov.modalidadTransporte)
      // setCodigoPostal(mov.codigoPostal)
      setTecnologia(mov.tecnologia ? { value: mov.tecnologia, label: mov.tecnologia } : undefined);
      setColocacionDesechable(mov.colocacionDesechable ? { value: mov.colocacionDesechable, label: mov.colocacionDesechable } : undefined);
      setColoca(mov.coloca ? { value: mov.coloca, label: mov.coloca } : undefined);
      setOv(mov.ov ? mov.ov : "");
      setRazonSocialFacturar(mov.razonSocialFacturar ? mov.razonSocialFacturar : "");
      
      // Cargar campos de contacto
      setContactoMonitoreo1(mov.contactoMonitoreo1 || "");
      setContactoMonitoreo2(mov.contactoMonitoreo2 || "");
      setContactoMonitoreo3(mov.contactoMonitoreo3 || "");
      setContactoLineaColocacion1(mov.contactoLineaColocacion1 || "");
      setContactoLineaColocacion2(mov.contactoLineaColocacion2 || "");
      setContactoLineaColocacion3(mov.contactoLineaColocacion3 || "");
      
      MovimientosObject = mov;
    }
  }, [currentMovimiento]);

  const isEnable = (Accion) => {
    //let borrar= "clientes_borrar";

    let actualizar = "movimientos_editar";
    let agregar = "movimientos_agregar";

    let actualizarCliente = "clientes_editar";
    let agregarCliente = "clientes_agregar";
    let actualizarTransportista = "transportistas_editar";
    let agregarTransportista = "transportistas_agregar";
    var privilegios = privilegios_object;
    var perfil = JSON.parse(sessionStorage.getItem("perfil"));
    for (let i = 0; i < privilegios.length; i++) {
      if (Accion === "actualizarCliente") {
        if (privilegios[i].clave === actualizarCliente) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio === privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
      if (Accion === "agregarCliente") {
        if (privilegios[i].clave === agregarCliente) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio === privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }

      if (Accion === "actualizarTransportista") {
        if (privilegios[i].clave === actualizarTransportista) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio === privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
      if (Accion === "agregarTransportista") {
        if (privilegios[i].clave === agregarTransportista) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio === privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }

      //if(Accion === "borrar"){ if( privilegios[i].clave === borrar){ if(perfil.privilegios.filter(word => word.idPrivilegio === privilegios[i].id).length > 0 ){return true}}}
      if (Accion === "actualizar") {
        if (privilegios[i].clave === actualizar) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio === privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
      if (Accion === "agregar") {
        if (privilegios[i].clave === agregar) {
          if (
            perfil.privilegios.filter(
              (word) => word.idPrivilegio === privilegios[i].id
            ).length > 0
          ) {
            return true;
          }
        }
      }
    }
    return false;
  };
  const reset = () => {
    //limpiamos el objeto movimiento
    MovimientosObject = {
      idPlataforma: plataformas.length === 1 ? idPlataforma.data : {},//requerido
      idNaviera: { id: "1", nombre: "Sin naviera" },//Default
      idOperacionTipo: [4, 61, 1381, 1480].includes(idPlataforma.value) && idOperacionTipo.data ? idOperacionTipo.data : {},//requerido
      idMovimientoTipo: {},//requerido
      idTransportista: null,//opcional
      idCliente: null,//opcional
      idClienteNaviero: null,//opcional
      idCorredor: {},//requerido
      idLocalidad: null,//opcional transmodal
      idLocalidadMT: null,
      destino: "",//opcional
      contenedor: "",//requerido
      contenedorTipo: 1,
      contenedorSize: 0,
      booking: "",
      po: "",
      sello: "",
      vip: true,
      nota: "",
      citaProgramada: null,
      citaProgramadaTerminal: null,
      citaColocacionGps: null,
      variables: {
        cuenta_espejo: {
          url: "",
          usuario: "",
          password: ""
        }
      },
      clienteS: null,
      transportistaS: null,
      entregas: [],
    };
    /**
     * Limpiamos entregas
     */
    // setCodigoPostal(undefined)
    setModalidadSeleccionada(undefined)
    setTecnologia(undefined)
    setColocacionDesechable(undefined)
    setColoca(undefined)
    setEntregasCarga([]);
    setEntregasDesCarga([]);
    setSinCobertura(undefined)
    setModalidadesSeleccionadas([]);
    /**
     * limpiamos los estados
     */
    //limpiamos variables
    let variablesObjTemp = { ...variablesObj };
    for (let v of variables) {//v.tipo, v.longitud, v.nombre, v.etiqueta
      switch (v.tipo) {
        case "String":
          MovimientosObject.variables[v.nombre] = "";
          if ([952].includes(idPlataforma.value) && v.nombre === "ejecutivo_transmodal") {
            variablesObjTemp[v.nombre] = { value: 0, label: "Selecciona un ejecutivo" };
          } else {
            variablesObjTemp[v.nombre] = "";
          }
          break
        case "Number":
          MovimientosObject.variables[v.nombre] = 0;
          variablesObjTemp[v.nombre] = 0;
          break;
        case "DateTime":
          MovimientosObject.variables[v.nombre] = null;
          variablesObjTemp[v.nombre] = null;
        case "Any":
          switch (v.nombre) {
            case "cuenta_espejo":
              MovimientosObject.variables.cuenta_espejo.url = "";
              MovimientosObject.variables.cuenta_espejo.usuario = "";
              MovimientosObject.variables.cuenta_espejo.password = "";
              variablesObjTemp["cuenta_espejo.url"] = "";
              variablesObjTemp["cuenta_espejo.usuario"] = "";
              variablesObjTemp["cuenta_espejo.password"] = "";
              break;
            default:
              break;
          }
          break;
        case "Boolean":
          MovimientosObject.variables[v.nombre] = false;
          variablesObjTemp[v.nombre] = false;
          break;
        default:
          break;
      }
    }
    setVariablesObj(variablesObjTemp);
    setVariables([]);
    //Se limpian catalogos requeridos
    if (plataformas.length === 1) {
      setIdPlataforma(plataformas[0]);
    } else {
      setIdPlataforma({ value: 0, label: "Selecciona una plataforma" });
    }
    setGpsTipoColocacion({ value: 0, label: "Selecciona una opción" });
    setIdCorredor({ value: 0, label: "No se ha seleccionado plataforma" });
    setPaisSeleccionado({ value: "mx", label: "MX" });
    setPaisLocalidad({ value: "MX", label: "MX" });
    setLocalidad({ value: 0, label: "No se ha seleccionado plataforma" });
    setlocalidadMT({ value: 0, label: "No se ha seleccionado plataforma" });
    setIdClienteNaviero({ value: 0, label: "No se ha seleccionado plataforma" });
    setIdCliente({ value: 0, label: "No se ha seleccionado plataforma" });
    setIdMovimientoTipo({ value: 0, label: "No se ha seleccionado plataforma" });
    if (![4, 61, 1381, 1480].includes(idPlataforma.value)) {
      setIdOperacionTipo({ value: 0, label: "No se ha seleccionado plataforma" });
    }
    setIdTransportista({ value: 0, label: "No se ha seleccionado plataforma" });
    setContenedorTipo({ value: 0, label: "Selecciona el tipo de carga", data: [], });
    setContenedorSize({ value: 0, label: "Selecciona el tamaño" });
    setEjecutivo("");
    setBooking("");
    setContenedor([]);
    setPo([]);
    setReferenciaFacturacion([]);
    setCitaProgramada("");
    setCitaProgramadaTerminal("");
    setCitaColocacionGps("");
    setDestino("");
    setEstado("");
    setMunicipio("");
    setColonia("");
    setCalle("");
    setNumero("");
    setCP("");
    setModelot("");
    setMarcat("");
    setColort("");
    setPlacat("");
    setEconomicot("");
    setPlacar("");
    setEconomicor("");
    setObservaciones("");
    setNombreOperador("");
    setMedioContacto("");
    setLicencia("");
    setNota("");
    setTecnologia(undefined);
    setColocacionDesechable(undefined);
    setColoca(undefined);
    setOv("");
    setRazonSocialFacturar("");
    setContactoMonitoreo1("");
    setContactoMonitoreo2("");
    setContactoMonitoreo3("");
    setContactoLineaColocacion1("");
    setContactoLineaColocacion2("");
    setContactoLineaColocacion3("");
    //setVariablesObj({});
    setNoContenedores(1);
    setNoPo(1);
    setCrudbutonEnable(true);
    guardando.current = false;
    setNuevo(true);
    setCurrentMovimiento({})
  }
  const getfuntion = async (metodo = "get", obj = [], id = "", catalogo = "cliente", stateVar = "clientes", hiddenModl = "") => {
    return Crud_Catalogos(catalogo, "movimientos", metodo, id, obj, "", stateVar, hiddenModl, [])
      .then((returnVal) => {
        switch (metodo) {
          case "get":
            if (stateVar === "variables") {
              setVariables(returnVal);
              let variablesObjTemp = {};
              for (let v of returnVal) {
                // Inicializar la propiedad en MovimientosObject.variables si no existe
                if (!MovimientosObject.variables.hasOwnProperty(v.nombre)) {
                  switch (v.tipo) {
                    case "String":
                      MovimientosObject.variables[v.nombre] = "";
                      break;
                    case "Number":
                      MovimientosObject.variables[v.nombre] = 0;
                      break;
                    case "DateTime":
                      MovimientosObject.variables[v.nombre] = null;
                      break;
                    case "Boolean":
                      MovimientosObject.variables[v.nombre] = false;
                      break;
                    default:
                      MovimientosObject.variables[v.nombre] = "";
                      break;
                  }
                }
                switch (v.tipo) {
                  case "String":
                    variablesObjTemp[v.nombre] = !nuevo ? currentMovimiento.variables[v.nombre] : "";
                    MovimientosObject.variables[v.nombre] = !nuevo ? currentMovimiento.variables[v.nombre] ? currentMovimiento.variables[v.nombre] : "" : "";
                    break
                  case "Number":
                    variablesObjTemp[v.nombre] = !nuevo ? currentMovimiento.variables[v.nombre] : 0;
                    MovimientosObject.variables[v.nombre] = !nuevo ? currentMovimiento.variables[v.nombre] ? currentMovimiento.variables[v.nombre] : 0 : 0;
                    break;
                  case "DateTime":
                    variablesObjTemp[v.nombre] = !nuevo ? currentMovimiento.variables[v.nombre] : null;
                    MovimientosObject.variables[v.nombre] = !nuevo ? currentMovimiento.variables[v.nombre] ? currentMovimiento.variables[v.nombre] : null : null;
                  case "Any":
                    switch (v.nombre) {
                      case "cuenta_espejo":
                        variablesObjTemp["cuenta_espejo.url"] = !nuevo ? currentMovimiento.variables[v.nombre].url : "";
                        variablesObjTemp["cuenta_espejo.usuario"] = !nuevo ? currentMovimiento.variables[v.nombre].usuario : "";
                        variablesObjTemp["cuenta_espejo.password"] = !nuevo ? currentMovimiento.variables[v.nombre].password : "";
                        //MovimientosObject.variables.cuenta_espejo.url= !nuevo? currentMovimiento.variables[v.nombre].url?currentMovimiento.variables[v.nombre].url: "": "";
                        //MovimientosObject.variablescuenta_espejo.usuario= !nuevo? currentMovimiento.variables[v.nombre].usuario?currentMovimiento.variables[v.nombre].usuario: "": "";
                        //MovimientosObject.variablescuenta_espejo.password= !nuevo? currentMovimiento.variables[v.nombre].password?currentMovimiento.variables[v.nombre].password: "": "";
                        break;
                      default:
                        break;
                    }
                    break;
                  case "Boolean":
                    variablesObjTemp[v.nombre] = !nuevo ? currentMovimiento.variables[v.nombre] : false;
                    MovimientosObject.variables[v.nombre] = !nuevo ? currentMovimiento.variables[v.nombre] ? currentMovimiento.variables[v.nombre] : false : false;
                    break;
                  default:
                    break;
                }
              }

              setVariablesObj(variablesObjTemp);
            }

            if (stateVar === "solicitudes_cliente") {
              let solicitudesTmp = [];
              for (let v of returnVal.sort((a, b) => b.idSolicitud - a.idSolicitud)) {
                v.variables = JSON.parse(v.variables);
                v.clienteS = JSON.parse(v.clienteS);
                v.transportistaS = JSON.parse(v.transportistaS);
                solicitudesTmp.push(v);
              }
              setSolicitudes(solicitudesTmp);
            }
            if (stateVar === "entregas") {
              //Solo se consideran 2 entregas
              //carga o consolidado
              setEntregasCarga(returnVal.filter(e => e.carga).sort((a, b) => a.orden - b.orden));
              //descarga o desconsolidado
              setEntregasDesCarga(returnVal.filter(e => !e.carga).sort((a, b) => a.orden - b.orden));
            }
            if (stateVar === "plataformas" && returnVal) {
              getfuntion("get", "", "", "gpsTipoColocacion", "gpsTipoColocacion");
              let plataformasTmp = [];
              for (let p of returnVal)
                plataformasTmp.push({ value: p.id, label: p.nombre, data: p });
              setPlataformas(plataformasTmp);
              if (plataformasTmp.length === 1) {
                changePlataformas(plataformasTmp[0]);
              } else if (plataformasTmp.every(p => [4, 61, 1381, 1480].includes(p.value))) {
                // Si todas las plataformas son terrestres, autoseleccionar la primera
                changePlataformas(plataformasTmp[0]);
              }
            }
            if (stateVar === "gpsTipoColocacion") {
              let gpsTipoColocacionTemp = [];
              var {id} = JSON.parse(sessionStorage.getItem("plataforma"));
              for (let gt of returnVal) {
                if (gt.id !== 6 && gt.id <= 7) {
                  if (id == 4 || id == 1381 || id == 1480) {
                    gpsTipoColocacionTemp.push({
                      value: gt.id,
                      label: (gt.nombre === "Respaldo" ? "Doble GPS" : gt.nombre && gt.nombre === "Principal" ? "Principal/Portátil/Recuperable" : gt.nombre),
                      data: gt,
                    });
                  } else {
                    gpsTipoColocacionTemp.push({
                      value: gt.id,
                      label: gt.nombre,
                      data: gt,
                    });
                  }
                }
              };
              setGpsTipoColocaciones(gpsTipoColocacionTemp);
              if (nuevo)
                setGpsTipoColocacion({ value: 0, label: "Selecciona una opción" });
            }
            if (stateVar === "corredores") {
              let corredoresTemp = [];
              returnVal.map((corredor, index) => {
                corredoresTemp.push({
                  value: corredor.id,
                  label: corredor.nombre,
                  data: corredor,
                  pais: corredor.pais || "mx",
                });
                if ([952].includes(idPlataforma.value) && corredor.id === 1) {
                  setIdCorredor(corredoresTemp[index]);
                  MovimientosObject.idCorredor = corredoresTemp[index].data;
                }
              });
              setCorredores(corredoresTemp);

              if (nuevo && ![952].includes(idPlataforma.value)) {
                setIdCorredor({ value: 0, label: "Selecciona un corredor" });
              }
            }
            if (stateVar === "ejecutivos") {
              const mov = { ...currentMovimiento };
              let ejecutivosTemp = [];
              returnVal.map((e) => {
                ejecutivosTemp.push({ value: e.id, label: e.nombre, data: e, });
                if (!nuevo && mov.variables && mov.variables.ejecutivo && e.nombre === mov.variables.ejecutivo) {
                  setEjecutivo(ejecutivosTemp[ejecutivosTemp.length - 1]);
                }
              });
              setEjecutivos(ejecutivosTemp);
              if (nuevo) {
                setEjecutivo({ value: 0, label: "Selecciona un ejecutivo" });
              }
            }
            if (stateVar === "localidades") {
              let localidadesTemp = [];
              returnVal.map((l, index) =>
                localidadesTemp.push({ 
                  value: l.id, 
                  label: l.nombre, 
                  data: l,
                })
              );
              setLocalidades(localidadesTemp);
              if (nuevo) {
                setLocalidad({ value: 0, label: "Selecciona una localidad" });
              }
            }
            if (stateVar === "localidadesMT") {
              let localidadesTemp = [];
              returnVal.map((l, index) =>
                localidadesTemp.push({ 
                  value: l.id, 
                  label: l.nombre, 
                  data: l,
                  pais: l.pais || "MX",
                })
              );
              setLocalidadesMT(localidadesTemp);
              if (nuevo) {
                setlocalidadMT({ value: 0, label: "Selecciona una localidad" });
              }
            }
            if (stateVar === "contenedorTipo") {
              let ContTipoTemp = [];
              for (let contTipo of returnVal) {
                if (nuevo) {
                  if (contTipo.id === 1)
                    setContenedorTipo({ value: contTipo.id, label: contTipo.nombre, data: contTipo });
                } else {
                  if (currentMovimiento.contenedorTipo === contTipo.id)
                    setContenedorTipo({ value: contTipo.id, label: contTipo.nombre, data: contTipo });
                }
                ContTipoTemp.push({ value: contTipo.id, label: contTipo.nombre, data: contTipo });
              };
              setContenedoresTipo(ContTipoTemp);
            }
            if (stateVar === "remolquesTipo") {
              let remolquesTipoTemp = [];
              for (let remTipo of returnVal) {
                // Estructura simplificada y consistente
                const remolqueData = {
                  id: remTipo.idRemolque,
                  nombre: remTipo.nombre
                };
                if (!nuevo && currentMovimiento.contenedorSize === remTipo.idRemolque)
                  setContenedorSize({ 
                    value: remTipo.idRemolque, 
                    label: remTipo.nombre, 
                    data: remolqueData 
                  });
                
                remolquesTipoTemp.push({ 
                  value: remTipo.idRemolque, 
                  label: remTipo.nombre, 
                  data: remolqueData 
                });
              }
              setRemolquesTipo(remolquesTipoTemp);
              if (nuevo)
                setContenedorSize({ value: 0, label: "Selecciona una tamaño de remolque" });
            }
            if (stateVar === "clientes") {
              let clientesTemp = [];
              if (returnVal.length > 0) {
                returnVal.map((client, index) =>
                  clientesTemp.push({
                    value: client.id,
                    label: client.nombre,
                    data: client,
                  })
                );
                setClientes(clientesTemp);
                if (nuevo) {
                  setIdCliente({ value: 0, label: "Selecciona un cliente" });
                }
              } else {
                setIdCliente({ value: 0, label: "No hay clientes" });
              }
            }
            if (stateVar === "clientesNavieros") {
              let clientesNav = [];
              if (returnVal.length > 0) {
                returnVal.map((client, index) =>
                  clientesNav.push({
                    value: client.id,
                    label: client.nombre,
                    data: client,
                  })
                );
                setClientesNavieros(clientesNav);
                if (nuevo) {
                  setIdClienteNaviero({ value: 0, label: "Selecciona un cliente" });
                }
              } else {
                setIdClienteNaviero({ value: 0, label: "No hay clientes" });
              }
            }
            if (stateVar === "operacionesTipo") {
              let operacionesTemp = [];
              returnVal.map((op, index) => {
                operacionesTemp.push({
                  value: op.id,
                  label: op.nombre,
                  data: op,
                });;
                if (op.id === 2 && nuevo && [4, 61, 1381, 1480].includes(idPlataforma.value)) {
                  setIdOperacionTipo(operacionesTemp[index]);
                  MovimientosObject.idOperacionTipo = operacionesTemp[index].data;
                }
              });
              if (nuevo && ![4, 61, 1381, 1480].includes(idPlataforma.value)) {
                setIdOperacionTipo({ value: 0, label: "Selecciona un tipo de operación" });
              }
              setOperacionTipos(operacionesTemp);
            }
            if (stateVar === "movimientosTipo") {
              let movimientoTiposTemp = [];
              returnVal.map((mt, index) =>
                movimientoTiposTemp.push({
                  value: mt.id,
                  label: mt.nombre,
                  data: mt,
                })
              );
              setMovimientosTipo(movimientoTiposTemp);
              if (nuevo) {
                setIdMovimientoTipo({ value: 0, label: "Selecciona un Tipo de movimiento" },);
              }
            }
            if (stateVar === "transportistas") {
              let transportistasTemp = [];
              for (let t of returnVal) {
                transportistasTemp.push({
                  value: t.id,
                  label: t.nombre,
                  data: t,
                });
              }
              setTransportistas(transportistasTemp);
              if (nuevo) {
                setIdTransportista({ value: 0, label: "Selecciona un Transportistas", },);
              }
            }
            if (stateVar === "modalidad") {
              setModalidades(returnVal.sort((a, b) => {
                if (a.name === "Carretero") return -1;
                if (b.name === "Carretero") return 1;
                return a.name.localeCompare(b.name);
              }))
            }
            if (stateVar === "coberturas") {
              setSinCobertura(!returnVal)
            }
            break;
          case "post":
            if (stateVar === "solicitudes_cliente") {
              if (returnVal.idSolicitud) {
                NotificationManager.info(
                  "Se ha generado la solicitud con el siguiente identificador: " + returnVal.idSolicitud, "Nuevo"
                );
              } else {
                NotificationManager.error(
                  "Parece que hubo un error al procesar la información, verifica a la izquierda que se haya genereado la solicitud",
                  "Nuevo");
              }
              getSolicitudes();
              return returnVal;
            }
            if (stateVar === "clientes") {
              if (returnVal.id) {
                getfuntion(
                  "post",
                  {
                    idPlataforma: idPlataforma.value,
                    idCliente: returnVal.id,
                  },
                  "",
                  "plataformasClientes",
                  "plataformasClientes"
                );
                NotificationManager.info(
                  "Se ha agregado el cliente al catlogo general( " +
                  returnVal.nombre +
                  " )",
                  "Nuevo"
                );
                let clientesTemp = clientes;
                clientesTemp.push({
                  value: returnVal.id,
                  label: returnVal.nombre,
                  data: returnVal,
                });
                MovimientosObject.idCliente = returnVal;
                setClientes(clientesTemp);

                setIdCliente({ value: returnVal.id, label: returnVal.nombre, data: returnVal, },);
              }
            }
            if (stateVar === "plataformasClientes") {
              if (returnVal.idPlataforma) {
                NotificationManager.info(
                  "El cliente ahora pertenece a la plataforma( " +
                  idPlataforma.value +
                  " )",
                  "Nuevo"
                );
              }
            }
            if (stateVar === "navieraMovimientos" && returnVal.id) {
              usuariosLogObject.idBitacoraMonitoreo = 1;
              usuariosLogObject.idUsuario = user.id;
              usuariosLogObject.idMovimiento = returnVal.id;
              usuariosLogObject.idPlataformaTipo = 1;
              usuariosLogObject.accionFecha = timeToDateFill(
                new Date().getTime()
              );
              usuariosLogObject.descripcion = "Nuevo Movimiento";
              Crud_Catalogos(
                "usuariosLog",
                "bitacoraMov",
                "post",
                "",
                usuariosLogObject
              );
            }
            break;
          case "put":
            if (stateVar === "solicitudes_cliente") {
              if (returnVal.idSolicitud) {
                NotificationManager.info(
                  "Se ha actualizado la solicitud con el siguiente identificador: " + returnVal.idSolicitud, "Actualización"
                );
              } else {
                NotificationManager.error(
                  "Parece que hubo un error al procesar la información, verifica a la izquierda que se haya actualizado la solicitud",
                  "Actualización");
              }
              getSolicitudes();
            }
            if (stateVar === "clientes") {
              if (returnVal.id) {
                NotificationManager.info(
                  "Se han agregado las modificaciones del cliente al catlogo general( " +
                  returnVal.nombre +
                  " )",
                  "Modificación"
                );
                let clientesTem = clientes;
                for (let item of clientesTem) {
                  if (item.id === returnVal.id) {
                    item = returnVal;
                  }
                }
                setClientes(clientesTem);
              }
            }
            if (stateVar === "navieraMovimientos" && returnVal.id) {
              usuariosLogObject.idBitacoraMonitoreo = 1;
              usuariosLogObject.idUsuario = user.id;
              usuariosLogObject.idMovimiento = returnVal.id;
              usuariosLogObject.idPlataformaTipo = 1;
              usuariosLogObject.accionFecha = timeToDateFill(
                new Date().getTime()
              );
              usuariosLogObject.descripcion =
                "Actualización de Movimiento";
              Crud_Catalogos(
                "usuariosLog",
                "bitacoraMov",
                "post",
                "",
                usuariosLogObject
              );
            }
            break;
          case "delete":
          default:
            break;
        }
        return returnVal;
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getfuntionPerso = (metodo = "get", obj = [], id = "", catalogo = "personas/plataforma/"+(idPlataforma?idPlataforma.value: null) , stateVar = "personas", hiddenModl = "") => {
      return Crud_Catalogos(catalogo, "movimientos", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
        /**
         * filtro de variables
         */
        switch (metodo) {
          case "post":
              if (stateVar === "personas") { 
                if(returnVal.id){
                  const mov = { ...currentMovimiento };
                  let idPlataformaTem= idPlataforma?idPlataforma.value: null
                  getfuntionPerso("post", idCliente.value, "", "contacto/"+idPlataformaTem+"/agregar?mail="+returnVal.correo+"&idMovimiento="+mov.idMovimiento, "solicitud" );
                  let contactosTem= contactos; 
                  contactosTem.unshift( returnVal );
                  //this.hiddenmodal();
                  ({ contactos: contactosTem });
                  getfuntionPerso("post", { "idCliente": idCliente.value, "idPersona": returnVal }, "", "clientesContactos", "clientesContactos", hiddenModl);        
                }
              }
              if (stateVar === "clientesContactos") {
                if(returnVal.idPersona){
                  NotificationManager.info("Contacto agregado, ingrese a su correo ("+returnVal.idPersona.correo+" ) para validar", "Nuevo");
                  
                  // Actualizar la lista de contactos después de agregar
                  setTimeout(async () => {
                    await obtenerContactos();
                    // Cerrar solo el modal de "Nuevo" y mantener abierto el modal "Movimiento"
                    setHiddenModals(false);
                  }, 500);
                }              
              }
            break;
          default:
            break;
        }
      }).catch(err => { console.log(err) });
    }
  const getfuntionTrans = (metodo = "get", obj = [], id = "", catalogo = "transportistas", stateVar = "transportistas", hiddenModl = "") => {
    Crud_Catalogos(catalogo, "movimientos", metodo, id, obj, "", stateVar, hiddenModl, [])
      .then((returnVal) => {
        switch (metodo) {
          case "post":
            if (stateVar === "transportistas") {
              if (returnVal.id) {
                getfuntionTrans(
                  "post",
                  {
                    plataforma: currentMovimiento.idPlataforma,
                    transportista: returnVal,
                  },
                  "",
                  "plataformasTransportistas",
                  "plataformasTransportistas"
                );
                NotificationManager.info(
                  "Se ha agregado el transportista al catlogo general( " +
                  returnVal.nombre +
                  " )",
                  "Nuevo"
                );
                let transportistasTemp = transportistas;
                transportistasTemp.push({
                  value: returnVal.id,
                  label: returnVal.nombre,
                  data: returnVal,
                });
                MovimientosObject.idTransportista = returnVal;
                setTransportistas(transportistasTemp);
                setIdTransportista({ value: returnVal.id, label: returnVal.nombre, data: returnVal, },);
              }
            }
            if (stateVar === "plataformasTransportistas") {
              if (returnVal.plataforma) {
                NotificationManager.info(
                  "El transportista ahora pertenece a la plataforma( " +
                  returnVal.plataforma.nombre +
                  " )",
                  "Nuevo"
                );
              }
            }
            break;
          case "put":
            if (stateVar === "transportistas") {
              if (returnVal.id) {
                NotificationManager.info(
                  "Se han agregado las modificaciones del transportista al catalogo general( " +
                  returnVal.nombre +
                  " )",
                  "Modificación"
                );
                let transportistasTem = transportistas;
                for (let item of transportistasTem) {
                  if (item.id === returnVal.id) {
                    item = returnVal;
                  }
                }
                setTransportistas(transportistasTem);
                setIdTransportista({ value: returnVal.id, label: returnVal.nombre, data: returnVal, },);
              }
            }
            break;
          default:
            break;
        }
      })
      .catch((err) => console.log(err));
  };
  const getCatalogosPorPlataforma = (idPlt) => {
    getfuntion(
      "get",
      "",
      "",
      "variables/" + idPlt,
      "variables"
    );
    getfuntion(
      "get",
      "",
      "",
      "corredores/cli_usuario/" + idPlt,
      "corredores"
    );
    getfuntion(
      "get",
      "",
      "",
      "localidades/mt",
      "localidadesMT"
    );
    getfuntion(
      "get",
      "",
      "",
      "localidades/cli_usuario/" + idPlt,
      "localidades"
    );
    getfuntion(
      "get",
      "",
      "",
      "cliente/cli_usuario/" + idPlt,
      "clientes"
    );
    getfuntion(
      "get",
      "",
      "",
      "clientes_navieros/cli_usuario/" + idPlt,
      "clientesNavieros"
    );
    getfuntion(
      "get",
      "",
      "",
      "operacionesTipo/plataforma/" + idPlt,
      "operacionesTipo"
    );
    getfuntion(
      "get",
      "",
      "",
      "movimientosTipo/cli_usuario/" + idPlt,
      "movimientosTipo"
    );
    // Trae los transportistas
    getfuntion(
      "get",
      "",
      "",
      "transportistas/cli_usuario/" + idPlt,
      "transportistas"
    );

    if ([952].includes(idPlt)) {
      getfuntion(
        "get",
        "",
        "",
        "ejecutivos/plataforma/" + idPlt,
        "ejecutivos"
      );
    }
  }
  const enableSave = () => {
    const resultado = validarGuardado({
      idPlataforma, idCliente, idMovimientoTipo, destino, idCorredor, localidad,
      idTransportista, contenedorSize, contenedorTipo, contenedor, noContenedores,
      idOperacionTipo, po, noPo, ejecutivo, citaProgramada, citaProgramadaTerminal,
      citaColocacionGps, gpsTipoColocacion, tecnologia, estado, municipio, colonia, calle, numero, cp,
      modelot, marcat, colort, placat, economicot, placar, economicor,
      nombreOperador, medioContacto, coloca, colocacionDesechable, ov,
      contactoMonitoreo1, contactoMonitoreo2, contactoLineaColocacion1, contactoLineaColocacion2,
      razonSocialFacturar, referenciaFacturacion, isChecked, nuevo, modalidadesSeleccionadas,
    });
    // Mantiene compatibilidad: retorna true cuando NO se puede guardar (disabled)
    return !resultado.habilitado;
  };
  const reordenarEntregas = (entregasCargaTemp, entregasDesCargaTemp) => {
    let i = 1;
    for (let e of entregasCargaTemp) {
      e.orden = i;
      i++;
    }
    for (let e of entregasDesCargaTemp) {
      e.orden = i;
      i++;
    }
    return { carga: entregasCargaTemp, descarga: entregasDesCargaTemp };
  }
  const setEntregasAMov = (entregaObj) => {
    let entregasCargaTemp = [...entregasCarga];
    let entregasDesCargaTemp = [...entregasDesCarga];
    if (entregaObj.carga) {
      if (entregaObj.idEntrega && entregasCargaTemp.length) {
        for (let i = 0; i < entregasCargaTemp.length; i++) {
          if (entregasCargaTemp[i].orden === entregaObj.orden)
            entregasCargaTemp[i] = entregaObj;
        }
      } else {
        entregasCargaTemp.push(entregaObj);
        const entregasOrdenadas = reordenarEntregas([...entregasCargaTemp], [...entregasDesCargaTemp]);
        entregasCargaTemp = entregasOrdenadas.carga;
        entregasDesCargaTemp = entregasOrdenadas.descarga;
      }
    } else {
      if (entregaObj.idEntrega && entregasDesCargaTemp.length) {
        for (let i = 0; i < entregasDesCargaTemp.length; i++) {
          if (entregasDesCargaTemp[i].orden === entregaObj.orden)
            entregasDesCargaTemp[i] = entregaObj;
        }
      } else {
        entregasDesCargaTemp.push(entregaObj)
        const entregasOrdenadas = reordenarEntregas([...entregasCargaTemp], [...entregasDesCargaTemp]);
        entregasCargaTemp = entregasOrdenadas.carga;
        entregasDesCargaTemp = entregasOrdenadas.descarga;
      }
    }
    setEntregasCarga(entregasCargaTemp);
    setEntregasDesCarga(entregasDesCargaTemp);
    setTimeout(() => {
      setHiddenModals(false);
    }, 200);
  }
  const guardarModalidades = async (idSolicitud) => {
  try {
    // Si no hay modalidades seleccionadas, no hacer nada
    if (modalidadesSeleccionadas.length === 0) {
      console.log("No hay modalidades seleccionadas para guardar");
      return;
    }
    
    console.log("Guardando modalidades para solicitud:", idSolicitud);
    
    // Guardar cada modalidad seleccionada
    for (const modalidad of modalidadesSeleccionadas) {
      const solicitudModalidad = {
        idSolicitud: idSolicitud,
        idModalidad: modalidad.id
      };
      
      await Axios.post(
        `${api_raiz}solicitudes_modalidades_transporte`,
        solicitudModalidad
      );
    }
    
    console.log("Modalidades guardadas correctamente");
  } catch (error) {
    console.error("Error al guardar modalidades:", error);
    NotificationManager.error(
      "Hubo un error al guardar las modalidades de transporte",
      "Error"
    );
  }
};
const cargarModalidadesSolicitud = async (idSolicitud) => {
  try {
    console.log("Cargando modalidades para solicitud:", idSolicitud);
    
    const response = await Axios.get(
      `${api_raiz}solicitudes_modalidades_transporte/solicitud/${idSolicitud}`
    );
    
    if (response.data && response.data.length > 0) {
      // Mapear los IDs de modalidades a objetos completos de modalidad
      const modalidadesIds = response.data.map(sm => sm.idModalidad);
      
      // Asegurarse de que tenemos modalidades cargadas
      if (modalidades.length === 0) {
        // Si modalidades no está cargado, cargarlo
        const modalidadesResponse = await Axios.get(`${api_raiz}modalidades-transporte`);
        setModalidades(modalidadesResponse.data);
        
        // Filtrar modalidades basadas en IDs
        const modalidadesCompletas = modalidadesResponse.data.filter(m => 
          modalidadesIds.includes(m.id)
        );
        setModalidadesSeleccionadas(modalidadesCompletas);
      } else {
        // Filtrar modalidades basadas en IDs usando el catálogo ya cargado
        const modalidadesCompletas = modalidades.filter(m => 
          modalidadesIds.includes(m.id)
        );
        setModalidadesSeleccionadas(modalidadesCompletas);
      }
    } else {
      // Si no hay modalidades, limpiar el estado
      setModalidadesSeleccionadas([]);
    }
  } catch (error) {
    console.error("Error al cargar modalidades de la solicitud:", error);
  }
};
   const guardarMovimiento = async () => {
    // Mostrar confirmación solo para edición (cuando no es nuevo)
    if (!nuevo) {
      confirmAlert({
        title: 'Confirmar cambios',
        message: '¿Está seguro de guardar los cambios realizados?',
        buttons: [
          {
            label: 'Sí, guardar',
            onClick: () => ejecutarGuardado()
          },
          {
            label: 'Cancelar',
            onClick: () => {} // No hace nada, solo cierra el modal
          }
        ]
      });
      return; // Salir de la función, la confirmación manejará el guardado
    }
    
    // Si es nuevo, guardar directamente
    ejecutarGuardado();
  };

  const obtenerCambiosRealizados = (movimientoAnterior, movimientoNuevo) => {
    const cambios = [];
    
    // Campos principales a comparar
    const camposComparar = {
      'idCliente.nombre': 'Cliente',
      'idTransportista.nombre': 'Transportista',
      'idMovimientoTipo.nombre': 'Tipo de Movimiento',
      'idOperacionTipo.nombre': 'Tipo de Operación',
      'contenedor': 'Contenedor',
      'po': 'PO',
      'destino': 'Destino',
      'booking': 'Booking',
      'nota': 'Nota',
      'citaProgramada': 'Cita Programada',
      'citaProgramadaTerminal': 'Cita Terminal'
    };

    Object.keys(camposComparar).forEach(campo => {
      const valorAnterior = obtenerValorAnidado(movimientoAnterior, campo);
      const valorNuevo = obtenerValorAnidado(movimientoNuevo, campo);
      
      if (valorAnterior !== valorNuevo) {
        cambios.push(`${camposComparar[campo]}: "${valorAnterior}" → "${valorNuevo}"`);
      }
    });

    return cambios.length > 0 ? cambios.join('; ') : 'Sin cambios detectados';
  };

  const obtenerValorAnidado = (obj, path) => {
    return path.split('.').reduce((current, key) => current?.[key], obj) || '';
  };

  const ejecutarGuardado = async () => {
    // Refrescar solicitudes para tener datos actualizados antes de validar duplicados
    if (nuevo) {
      await getSolicitudes();
    }

    let movTemp = { ...MovimientosObject };

    if (idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value)) {
      movTemp.destino = `${estado}, ${municipio}, ${colonia}, ${calle}, ${numero}, ${cp}`;
      movTemp.idLocalidad = localidad.data ? localidad.data : null;
      
      // Convertir contenedor a mayúsculas antes de guardar
      if (movTemp.contenedor) {
        movTemp.contenedor = movTemp.contenedor.toUpperCase();
      }
    }
    
    // Agregar campos de contacto SIEMPRE (no solo para plataformas específicas)
    movTemp.contactoMonitoreo1 = contactoMonitoreo1;
    movTemp.contactoMonitoreo2 = contactoMonitoreo2;
    movTemp.contactoMonitoreo3 = contactoMonitoreo3;
    movTemp.contactoLineaColocacion1 = contactoLineaColocacion1;
    movTemp.contactoLineaColocacion2 = contactoLineaColocacion2;
    movTemp.contactoLineaColocacion3 = contactoLineaColocacion3;
    movTemp.ov = ov;
    movTemp.razonSocialFacturar = razonSocialFacturar;
    // Solo asignar datos de unidad y operador si se cumplen las condiciones específicas
    if ([4, 61, 1381, 1480].includes(idPlataforma.value) && 
        (gpsTipoColocacion.value === 7 || (coloca && coloca.value === 'Coloca cliente'))) {
      movTemp.modelot = modelot;
      movTemp.marcat = marcat;
      movTemp.colort = colort;
      movTemp.placat = placat;
      movTemp.economicot = economicot;
      movTemp.placar = placar;
      movTemp.economicor = economicor;
      movTemp.observaciones = observaciones;
      movTemp.nombreOperador = nombreOperador;
      movTemp.medioContacto = medioContacto;
      movTemp.licencia = licencia;
    } else {
      delete movTemp.modelot;
      delete movTemp.marcat;
      delete movTemp.colort;
      delete movTemp.placat;
      delete movTemp.economicot;
      delete movTemp.placar;
      delete movTemp.economicor;
      delete movTemp.observaciones;
      delete movTemp.nombreOperador;
      delete movTemp.medioContacto;
      delete movTemp.licencia;
    }
    movTemp.idPlataforma = idPlataforma.data;
    movTemp.modalidadTransporte = modalidadSeleccionada;
    movTemp.idGgpsTipoColocacion = gpsTipoColocacion.data;
    if (tecnologia) {
      movTemp.tecnologia = tecnologia.value;
      movTemp.colocacionDesechable = colocacionDesechable.value;
      movTemp.coloca = coloca.value;
    }

    // Array para acumular contenedores fallidos
    const contenedoresFallidos = [];

    // Procesar según si es un movimiento por contenedor o no
    if (unMovimientoPorContenedor && noContenedores === noPo) {
      for (let i = 0; i < noContenedores; i++) {
        if (contenedor[i] && contenedor[i].length) {
          // Validar duplicado: buscar contenedor exacto en solicitudes activas
          if (nuevo) {
            const contenedorUpper = contenedor[i].toUpperCase();
            const esDuplicado = solicitudes.some(sol => {
              if (!sol.contenedor || sol.cancelado) return false;
              const contenedoresSol = sol.contenedor.split(";").map(c => c.trim().toUpperCase());
              return contenedoresSol.includes(contenedorUpper);
            });
            if (esDuplicado) {
              contenedoresFallidos.push(contenedor[i]);
              continue;
            }
          }

          const tempMovimiento = { ...movTemp };
          
          if ([270].includes(movTemp.idMovimientoTipo.id)) {
            tempMovimiento.entregas = [...entregasCarga, ...entregasDesCarga];
          }
          
          tempMovimiento.contenedor = contenedor[i];
          tempMovimiento.po = po[i];
          
          // Asignar referencia de facturación individual por contenedor
          if ([4, 61, 1381, 1480].includes(idPlataforma.value)) {
            tempMovimiento.variables = { ...tempMovimiento.variables };
            tempMovimiento.variables.referencia_facturacion = isChecked ? "" : (referenciaFacturacion[i] || "");
          }
          
          // Asegurar que los contactos y OV se copien
          tempMovimiento.contactoMonitoreo1 = movTemp.contactoMonitoreo1;
          tempMovimiento.contactoMonitoreo2 = movTemp.contactoMonitoreo2;
          tempMovimiento.contactoMonitoreo3 = movTemp.contactoMonitoreo3;
          tempMovimiento.contactoLineaColocacion1 = movTemp.contactoLineaColocacion1;
          tempMovimiento.contactoLineaColocacion2 = movTemp.contactoLineaColocacion2;
          tempMovimiento.contactoLineaColocacion3 = movTemp.contactoLineaColocacion3;
          tempMovimiento.ov = movTemp.ov;
          
          // Serializar correctamente los objetos
          tempMovimiento.variables = JSON.stringify(tempMovimiento.variables);
          tempMovimiento.clienteS = tempMovimiento.clienteS ? JSON.stringify(tempMovimiento.clienteS) : "null";
          tempMovimiento.transportistaS = tempMovimiento.transportistaS ? JSON.stringify(tempMovimiento.transportistaS) : "null";
          // Eliminar modalidadTransporte si es undefined
          if (tempMovimiento.modalidadTransporte === undefined) {
            delete tempMovimiento.modalidadTransporte;
          }

          if (!nuevo) {
            await crud_put(movTemp);
          } else {
            // Llamar a crud_post y guardar modalidades con el idSolicitud devuelto
            const resultado = await crud_post(tempMovimiento);
            
            // Agregar delay de 500ms entre solicitudes para evitar problemas de concurrencia
            await new Promise(resolve => setTimeout(resolve, 500));

            // Validar que se haya creado correctamente
            if (!resultado || !resultado.idMovimiento) {
              contenedoresFallidos.push(contenedor[i]);
              continue;
            }
            
            // Intentar obtener el ID de diferentes formas
            const solicitudId = resultado?.idSolicitud || resultado?.id;
            const movimientoId = resultado?.idMovimiento || resultado?.id;
            
            if (resultado && solicitudId) {
              await guardarModalidades(solicitudId);
              
              // Enviar notificación por correo
              if (movimientoId) {
                try {
                  await Axios.post(`${api_raiz}mail/arrobanaviera/${movimientoId}/24?nota=null`);
                } catch (error) {
                  console.error("Error al enviar notificación:", error);
                }
                // Guardar movimientosPatio si aplica (solo al crear)
                if ([4, 61, 1381, 1480].includes(idPlataforma.value) &&
                    (gpsTipoColocacion.value === 7 || (coloca && coloca.value === 'Coloca cliente'))) {
                  try {
                    await Axios.post(`${api_raiz}movimientosPatio`, {
                      idMovimiento: movimientoId,
                      idRemolque: { idRemolque: contenedorSize.value },
                      operadorNombre: nombreOperador || "", operadorContacto: medioContacto || "", operadorLicencia: licencia || "",
                      tractorModelo: modelot || "", tractorMarca: marcat || "", tractorColor: colort || "",
                      tractorPlaca: placat || "", remolquePlaca: placar || "", observaciones: observaciones || "",
                      economicot: economicot || "", economicor: economicor || "", enProtocolo: false
                    });
                  } catch (error) {
                    console.error("Error al guardar movimientosPatio:", error);
                  }
                }
              }
              
            } else {
              console.error("No se pudo obtener el ID de la solicitud después de crearla");
            }
          }
        }
      }
    } else {
      // Si no se trata de movimientos individuales por contenedor
      let contenedorTemp = "";
      let poTemp = "";
      for (let i = 0; i < noContenedores; i++) {
        if (contenedor[i] && contenedor[i].length) {
          // Validar duplicado antes de concatenar
          if (nuevo) {
            const contenedorUpper = contenedor[i].toUpperCase();
            const esDuplicado = solicitudes.some(sol => {
              if (!sol.contenedor || sol.cancelado) return false;
              const contenedoresSol = sol.contenedor.split(";").map(c => c.trim().toUpperCase());
              return contenedoresSol.includes(contenedorUpper);
            });
            if (esDuplicado) {
              contenedoresFallidos.push(contenedor[i]);
              continue;
            }
          }
          contenedorTemp = contenedorTemp + (contenedorTemp.length ? ";" : "") + contenedor[i];
        }
      }

      // Si todos los contenedores son duplicados, no enviar nada
      if (nuevo && contenedorTemp.length === 0 && contenedoresFallidos.length > 0) {
        confirmAlert({
          title: '⚠️ Contenedores no generados',
          message: `Los siguientes contenedores ya existen: ${contenedoresFallidos.join(', ')}`,
          buttons: [{ label: 'Entendido', onClick: () => {} }]
        });
        setCrudbutonEnable(true);
        guardando.current = false;
        return;
      }
      for (let i = 0; i < noPo; i++) {
        if (po[i] && po[i].length) {
          poTemp = poTemp + (poTemp.length ? ";" : "") + po[i];
        }
      }
      if ([270].includes(movTemp.idMovimientoTipo.id)) {
        movTemp.entregas = [...entregasCarga, ...entregasDesCarga];
      }
      movTemp.contenedor = contenedorTemp;
      movTemp.po = poTemp;
      // Asignar referencia de facturación concatenada para un solo movimiento
      if ([4, 61, 1381, 1480].includes(idPlataforma.value)) {
        let refTemp = "";
        for (let i = 0; i < noContenedores; i++) {
          if (referenciaFacturacion[i] && referenciaFacturacion[i].length) {
            refTemp = refTemp + (refTemp.length ? ";" : "") + referenciaFacturacion[i];
          }
        }
        movTemp.variables.referencia_facturacion = isChecked ? "" : refTemp;
      }
      // Serializar correctamente los objetos
      movTemp.variables = JSON.stringify(movTemp.variables);
      movTemp.clienteS = movTemp.clienteS ? JSON.stringify(movTemp.clienteS) : "null";
      movTemp.transportistaS = movTemp.transportistaS ? JSON.stringify(movTemp.transportistaS) : "null";
      // Eliminar campos que no existen en la entidad
      delete movTemp.calle;
      delete movTemp.colonia;
      delete movTemp.cp;
      delete movTemp.estado;
      delete movTemp.municipio;
      delete movTemp.numero;
      delete movTemp.modalidadesSeleccionadas;
      delete movTemp.modelor;
      // Eliminar modalidadTransporte si es undefined
      if (movTemp.modalidadTransporte === undefined) {
        delete movTemp.modalidadTransporte;
      }
  
      if (!nuevo) {
        await crud_put(movTemp);
      } else {
        // Llamar a crud_post y guardar modalidades con el idSolicitud devuelto
        const resultado = await crud_post(movTemp);
        
        // Validar que se haya creado correctamente con idMovimiento
        if (!resultado || !resultado.idMovimiento) {
          confirmAlert({
            title: 'Error al crear solicitud',
            message: 'No se pudo generar el movimiento. El contenedor puede estar duplicado.',
            buttons: [
              {
                label: 'Entendido',
                onClick: () => {}
              }
            ]
          });
          setCrudbutonEnable(true);
          guardando.current = false;
          return;
        }
        
        // Intentar obtener el ID de diferentes formas
        const solicitudId = resultado?.idSolicitud || resultado?.id;
        const movimientoId = resultado?.idMovimiento || resultado?.id;
        
        if (resultado && solicitudId) {
          await guardarModalidades(solicitudId);
          
          // Enviar notificación por correo
          if (movimientoId) {
            try {
              await Axios.post(`${api_raiz}mail/arrobanaviera/${movimientoId}/24?nota=null`);
            } catch (error) {
              console.error("Error al enviar notificación:", error);
            }
            // Guardar movimientosPatio si aplica (solo al crear)
            if ([4, 61, 1381, 1480].includes(idPlataforma.value) &&
                (gpsTipoColocacion.value === 7 || (coloca && coloca.value === 'Coloca cliente'))) {
              try {
                await Axios.post(`${api_raiz}movimientosPatio`, {
                  idMovimiento: movimientoId,
                  idRemolque: { idRemolque: contenedorSize.value },
                  operadorNombre: nombreOperador || "", operadorContacto: medioContacto || "", operadorLicencia: licencia || "",
                  tractorModelo: modelot || "", tractorMarca: marcat || "", tractorColor: colort || "",
                  tractorPlaca: placat || "", remolquePlaca: placar || "", observaciones: observaciones || "",
                  economicot: economicot || "", economicor: economicor || "", enProtocolo: false
                });
              } catch (error) {
                console.error("Error al guardar movimientosPatio:", error);
              }
            }
          }
        }
      }
    }

    // Cerrar el formulario PRIMERO
    setIsFormOpen(false);

    // Mostrar alerta de fallidos DESPUÉS de cerrar el modal
    if (contenedoresFallidos.length > 0) {
      confirmAlert({
        title: '⚠️ Contenedores no generados',
        message: `Los siguientes contenedores ya existen: ${contenedoresFallidos.join(', ')}`,
        buttons: [{ label: 'Entendido', onClick: () => {} }]
      });
    }

    setCrudbutonEnable(false);
    reset();
    initializeData();
  };


  //************ Combos ***********************
  const changePlataformas = (event) => {

    setIdPlataforma(event);
  };

  const changeCliente = (event) => {
    MovimientosObject.idCliente = event.data;
    setIdCliente(event);
  };
  const changeClienteNaviero = (event) => {
    MovimientosObject.idClienteNaviero = event.data;
    setIdClienteNaviero(event);
  };

  const changeContenedorTipo = (event) => {
    MovimientosObject.contenedorTipo = event.value;
    setContenedorTipo(event);
  };
  const changeTecnologia = (event) => {
    setTecnologia(event)
  };
  const changeColoca = (event) => {
    setColoca(event);
  };
  const changeColocacionDesechable = (event) => {
    setColocacionDesechable(event)
  };
  const changeContenedorSize = (event) => {
      MovimientosObject.contenedorSize = event.value;
      setContenedorSize(event);
  };
  const changeDestino = (event) => {
    MovimientosObject.destino = event.target.value;
    setDestino(event.target.value);
  };
  const changeNota = (event) => {
    if (event.target.value.length <= 2000) {
      MovimientosObject.nota = event.target.value;
      setNota(event.target.value);
    }
  };

  const changeCorredor = (event) => {
    MovimientosObject.idCorredor = event.data;
    setIdCorredor(event);
  };
  const changeEjecutivo = (event) => {
    MovimientosObject.variables.ejecutivo = event.label;
    setEjecutivo(event);
  };
  const changeLocalidad = (event) => {
    MovimientosObject.idLocalidad = event.data;
    setLocalidad(event);
  };
  const changelocalidadMT = (event) => {
    MovimientosObject.idLocalidadMT = event.data;
    setlocalidadMT(event);
  };
  const changeMovimientoTipo = (event) => {
    MovimientosObject.idMovimientoTipo = event.data;
    setIdMovimientoTipo(event);
  };
  const changeOperacionTipo = (event) => {
    MovimientosObject.idOperacionTipo = event.data;
    setIdOperacionTipo(event);
  };
  const changeTransportista = (event) => {
    MovimientosObject.idTransportista = event.data;
    setIdTransportista(event);
  };
  //Campos Normales

  const onChangeDate = (date) => {
    console.log("error", date)
    MovimientosObject.citaProgramada = timeToDateFill(
      new Date(date).getTime()
    );
    date != null
      ? setCitaProgramada(date)
      : setCitaProgramada(date);
  };
  const onChangeCitaProgramadaTerminal = (date) => {
    MovimientosObject.citaProgramadaTerminal = timeToDateFill(
      new Date(date).getTime()
    );
    date != null
      ? setCitaProgramadaTerminal(date)
      : setCitaProgramadaTerminal(date);
  };
  const onChangeCitaColocacionGps = (date) => {
    MovimientosObject.citaColocacionGps = date ? timeToDateFill(new Date(date).getTime()) : null;
    setCitaColocacionGps(date != null ? date : "");
  };
const handleModalidadChange = (modalidad) => {
  // Verificar si la modalidad ya está seleccionada
  const isSelected = modalidadesSeleccionadas.some(m => m.id === modalidad.id);
  
  if (isSelected) {
    // Si ya está seleccionada, la eliminamos
    const nuevasModalidades = modalidadesSeleccionadas.filter(m => m.id !== modalidad.id);
    setModalidadesSeleccionadas(nuevasModalidades);
    // También actualizar MovimientosObject para mantener consistencia
    MovimientosObject.modalidadesSeleccionadas = nuevasModalidades;
  } else {
    // Si no está seleccionada, la añadimos
    const nuevasModalidades = [...modalidadesSeleccionadas, modalidad];
    setModalidadesSeleccionadas(nuevasModalidades);
    // También actualizar MovimientosObject para mantener consistencia
    MovimientosObject.modalidadesSeleccionadas = nuevasModalidades;
  }
  };

  const crud_put = async (obj) => {
  if (!guardando.current) {
    guardando.current = true;
    try {
      const cambiosDetectados = obtenerCambiosRealizados(currentMovimiento, obj);
      
      const objLimpio = {
        idSolicitud: obj.idSolicitud,
        idMovimiento: obj.idMovimiento,
        idUsuarioCrea: obj.idUsuarioCrea || currentMovimiento.idUsuarioCrea,
        idPlataforma: obj.idPlataforma?.id ? { id: obj.idPlataforma.id } : (currentMovimiento.idPlataforma ? { id: currentMovimiento.idPlataforma.id } : null),
        idNaviera: obj.idNaviera?.id ? { id: obj.idNaviera.id } : (currentMovimiento.idNaviera ? { id: currentMovimiento.idNaviera.id } : null),
        idOperacionTipo: obj.idOperacionTipo?.id ? { id: obj.idOperacionTipo.id } : (currentMovimiento.idOperacionTipo ? { id: currentMovimiento.idOperacionTipo.id } : null),
        idMovimientoTipo: obj.idMovimientoTipo?.id ? { id: obj.idMovimientoTipo.id } : (currentMovimiento.idMovimientoTipo ? { id: currentMovimiento.idMovimientoTipo.id } : null),
        idTransportista: obj.idTransportista?.id ? { id: obj.idTransportista.id } : (currentMovimiento.idTransportista ? { id: currentMovimiento.idTransportista.id } : null),
        idCliente: obj.idCliente?.id ? { id: obj.idCliente.id } : (currentMovimiento.idCliente ? { id: currentMovimiento.idCliente.id } : null),
        idClienteNaviero: obj.idClienteNaviero?.id ? { id: obj.idClienteNaviero.id } : (currentMovimiento.idClienteNaviero ? { id: currentMovimiento.idClienteNaviero.id } : null),
        idCorredor: obj.idCorredor?.id ? { id: obj.idCorredor.id } : (currentMovimiento.idCorredor ? { id: currentMovimiento.idCorredor.id } : null),
        idLocalidad: obj.idLocalidad?.id ? { id: obj.idLocalidad.id } : (currentMovimiento.idLocalidad ? { id: currentMovimiento.idLocalidad.id } : null),
        idLocalidadMT: obj.idLocalidadMT?.id ? { id: obj.idLocalidadMT.id } : (currentMovimiento.idLocalidadMT ? { id: currentMovimiento.idLocalidadMT.id } : null),
        idGgpsTipoColocacion: obj.idGgpsTipoColocacion?.id ? { id: obj.idGgpsTipoColocacion.id } : (currentMovimiento.idGgpsTipoColocacion ? { id: currentMovimiento.idGgpsTipoColocacion.id } : null),
        idPatioVacio: obj.idPatioVacio?.id ? { id: obj.idPatioVacio.id } : (currentMovimiento.idPatioVacio ? { id: currentMovimiento.idPatioVacio.id } : null),
        destino: obj.destino || currentMovimiento.destino,
        contenedor: obj.contenedor !== undefined && obj.contenedor !== null ? obj.contenedor : currentMovimiento.contenedor,
        contenedorTipo: obj.contenedorTipo || currentMovimiento.contenedorTipo,
        contenedorSize: obj.contenedorSize || currentMovimiento.contenedorSize,
        booking: obj.booking !== undefined ? obj.booking : currentMovimiento.booking,
        po: obj.po !== undefined ? obj.po : currentMovimiento.po,
        sello: obj.sello !== undefined ? obj.sello : currentMovimiento.sello,
        nota: obj.nota !== undefined ? obj.nota : currentMovimiento.nota,
        vip: obj.vip !== undefined ? obj.vip : currentMovimiento.vip,
        citaProgramada: obj.citaProgramada || currentMovimiento.citaProgramada,
        citaProgramadaTerminal: obj.citaProgramadaTerminal || currentMovimiento.citaProgramadaTerminal,
        citaColocacionGps: obj.citaColocacionGps || currentMovimiento.citaColocacionGps,
        variables: typeof obj.variables === 'string' ? obj.variables : JSON.stringify(obj.variables),
        clienteS: obj.clienteS !== undefined ? obj.clienteS : currentMovimiento.clienteS,
        transportistaS: obj.transportistaS !== undefined ? obj.transportistaS : currentMovimiento.transportistaS,
        tecnologia: obj.tecnologia !== undefined ? obj.tecnologia : currentMovimiento.tecnologia,
        codigoPostal: obj.codigoPostal !== undefined ? obj.codigoPostal : currentMovimiento.codigoPostal,
        colocacionDesechable: obj.colocacionDesechable !== undefined ? obj.colocacionDesechable : currentMovimiento.colocacionDesechable,
        coloca: obj.coloca !== undefined ? obj.coloca : currentMovimiento.coloca,
        ov: obj.ov !== undefined ? obj.ov : currentMovimiento.ov,
        contactoMonitoreo1: obj.contactoMonitoreo1 !== undefined ? obj.contactoMonitoreo1 : currentMovimiento.contactoMonitoreo1,
        contactoMonitoreo2: obj.contactoMonitoreo2 !== undefined ? obj.contactoMonitoreo2 : currentMovimiento.contactoMonitoreo2,
        contactoMonitoreo3: obj.contactoMonitoreo3 !== undefined ? obj.contactoMonitoreo3 : currentMovimiento.contactoMonitoreo3,
        contactoLineaColocacion1: obj.contactoLineaColocacion1 !== undefined ? obj.contactoLineaColocacion1 : currentMovimiento.contactoLineaColocacion1,
        contactoLineaColocacion2: obj.contactoLineaColocacion2 !== undefined ? obj.contactoLineaColocacion2 : currentMovimiento.contactoLineaColocacion2,
        contactoLineaColocacion3: obj.contactoLineaColocacion3 !== undefined ? obj.contactoLineaColocacion3 : currentMovimiento.contactoLineaColocacion3,
        razonSocialFacturar: obj.razonSocialFacturar !== undefined ? obj.razonSocialFacturar : currentMovimiento.razonSocialFacturar,
      };
      
      const returnVal = await getfuntion(
        "put",
        objLimpio,
        "",
        "solicitudes_cliente?enviarCorreo=" + ([952].includes(idPlataforma.value) ? true : false),
        "solicitudes_cliente"
      );
      
      if (returnVal && returnVal.idSolicitud) {
        try {
          await Axios.delete(
            `${api_raiz}solicitudes_modalidades_transporte/solicitud/${returnVal.idSolicitud}`
          );
          if (modalidadesSeleccionadas.length > 0) {
            for (const modalidad of modalidadesSeleccionadas) {
              await Axios.post(
                `${api_raiz}solicitudes_modalidades_transporte`,
                { idSolicitud: returnVal.idSolicitud, idModalidad: modalidad.id }
              );
            }
          }
          
          if (returnVal.id) {
            usuariosLogObject.idBitacoraMonitoreo = 1;
            usuariosLogObject.idUsuario = user.id;
            usuariosLogObject.idMovimiento = returnVal.id;
            usuariosLogObject.idPlataformaTipo = 1;
            usuariosLogObject.accionFecha = timeToDateFill(new Date().getTime());
            usuariosLogObject.descripcion = `Actualización de Movimiento - Cambios: ${cambiosDetectados}`;
            Crud_Catalogos("usuariosLog", "bitacoraMov", "post", "", usuariosLogObject);
          }
          
          NotificationManager.success(
            "Solicitud y modalidades actualizadas correctamente",
            "Éxito"
          );
          
          getSolicitudes();
          setIsFormOpen(false);
          reset();
        } catch (error) {
          console.error("Error al actualizar modalidades:", error);
          NotificationManager.warning(
            "La solicitud se actualizó pero hubo un error con las modalidades",
            "Advertencia"
          );
        }
      }
      
      setCrudbutonEnable(false);
      return returnVal;
    } catch (error) {
      console.error("Error en crud_put:", error);
      return null;
    } finally {
      guardando.current = false;
    }
  }
  return null;
};

  const crud_post = async (obj) => {
    try {
      const resultado = await getfuntion(
        "post",
        obj,
        "",
        "solicitudes_cliente?enviarCorreo=" + ([952].includes(idPlataforma.value) ? true : false),
        "solicitudes_cliente"
      );
      return resultado;
    } catch (error) {
      console.error("Error en crud_post:", error);
      return null;
    }
  };

  // useEffect(() => {
  //   if (codigoPostal) {
  //     if (codigoPostal && codigoPostal.length === 5) {
  //       getfuntion(
  //         "get",
  //         "",
  //         "",
  //         "coberturas/checar-codigo-postal?zipCode=" + codigoPostal,
  //         "coberturas"
  //       )
  //     }
  //   }

  // }, [codigoPostal])

  /**
   * Privilegio activo
   */
  const estaPrivilegioActivo = (clave) => {
    var privilegios = privilegios_object; var perfil = JSON.parse(sessionStorage.getItem("perfil"));
    for (let i = 0; i < privilegios.length; i++) {
      if (privilegios[i].clave === clave) {
        if (perfil.privilegios.filter(word => word.idPrivilegio === privilegios[i].id).length > 0) { return true } else { return false }
      }
    }
  }
  const getForm = (tipo, longitud, nombre, etiqueta) => {
    let variablesObjTemp = { ...variablesObj };
    switch (tipo) {
      case "String":
      return (
          <>
          <Grid.Col md={4}>
            <Form.Group
              label={
                [952].includes(idPlataforma.value) && nombre === "ejecutivo_transmodal" ?
                  <div>
                    {etiqueta}
                    <label className="font-weight-bold text-danger">*</label>
                  </div> : etiqueta
              }
            >
              {[952].includes(idPlataforma.value) && nombre === "ejecutivo_transmodal" ? (
                <Select
                  value={ejecutivo}
                  onChange={changeEjecutivo}
                  options={ejecutivos}
                />
              ) : (
                <Form.Input
                  name={nombre}
                  type="text"
                  value={variablesObj[nombre]}
                  disabled={nombre === "referencia_facturacion" && isChecked}
                  style={{
                    backgroundColor:
                      nombre === "referencia_facturacion" && isChecked ? "#e9ecef" : "white",
                    ...([4, 61, 1381, 1480].includes(idPlataforma.value) ? { textTransform: "uppercase" } : {})
                  }}
                  onChange={(e) => {
                    if (e.target.value.length <= longitud) {
                      const nombreTemp = nombre.split(".");
                      const valor = [4, 61, 1381, 1480].includes(idPlataforma.value) ? e.target.value.toUpperCase() : e.target.value;
                      variablesObjTemp[nombre] = valor;
                      setVariablesObj(variablesObjTemp);
                      if (1 === nombreTemp.length)
                        MovimientosObject.variables[nombreTemp[0]] = valor;
                      if (2 === nombreTemp.length)
                        MovimientosObject.variables[nombreTemp[0]][nombreTemp[1]] =
                          valor;
                      if (3 === nombreTemp.length)
                        MovimientosObject.variables[nombreTemp[0]][nombreTemp[1]][
                          nombreTemp[2]
                        ] = valor;
                    }
                  }}
                  maxlength="30"
                />
              )}
              {[4, 61, 1381, 1480].includes(idPlataforma.value) && nombre === "referencia_facturacion" ? (
                <>
                  <label className="font-weight-bold">
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={(e) => {
                        const isCheckedValue = e.target.checked;
                        handleCheckboxChange(isCheckedValue); // Cambia el estado de `isChecked`

                        // Limpia el input si el checkbox está activo
                        if (isCheckedValue) {
                          variablesObjTemp[nombre] = ""; // Limpia el valor del campo
                          setVariablesObj({ ...variablesObjTemp }); // Actualiza el estado
                          MovimientosObject.variables[nombre] = ""; // Actualiza el objeto global
                        }
                      }}
                    />
                    N/A
                  </label>
                  <div className="text-danger mt-1 font-weight-bold">
                    Favor de considerar que con este dato/número de referencia se emitirá su factura.
                  </div>
                </>
              ) : null}
            </Form.Group>
          </Grid.Col>
          </>
      );

      case "Number":
        return (
          <Grid.Col md={4}>
            <Form.Group label={etiqueta}>
              {" "}
              <Form.Input
                name={nombre}
                type="number"
                value={variablesObj[nombre]}
                onChange={(e) => {
                  if (e.target.value.length <= longitud) {
                    const nombreTemp = nombre.split(".");
                    variablesObjTemp[nombre] = e.target.value;
                    setVariablesObj(variablesObjTemp);
                    if (1 === nombreTemp.length)
                      MovimientosObject.variables[nombreTemp[0]] = e.target.value;
                    if (2 === nombreTemp.length)
                      MovimientosObject.variables[nombreTemp[0]][nombreTemp[1]] = e.target.value;
                    if (3 === nombreTemp.length)
                      MovimientosObject.variables[nombreTemp[0][nombreTemp[1]][nombreTemp[2]]] = e.target.value;
                  }
                }}
                maxlength="30"
              />
            </Form.Group>{" "}
          </Grid.Col>);
      case "DateTime":
        return (
          <Grid.Col md={4}>
            <Form.Group label={
              [1].includes(idPlataforma.value)? (
                <>
                  {etiqueta}<label className="text-danger mt-1 font-weight-bold">*</label>
                </>
                ):etiqueta}>
              <DateTimePicker
                format="y-MM-dd h:mm:ss a"
                value={variablesObj[nombre]}
                onChange={(e) => {
                  const nombreTemp = nombre.split(".");
                  variablesObjTemp[nombre] = e;
                  setVariablesObj(variablesObjTemp);
                  if (1 === nombreTemp.length)
                    MovimientosObject.variables[nombreTemp[0]] = e ? timeToDateFill(new Date(e).getTime()) : e;
                  if (2 === nombreTemp.length)
                    MovimientosObject.variables[nombreTemp[0]][nombreTemp[1]] = e ? timeToDateFill(new Date(e).getTime()) : e;
                  if (3 === nombreTemp.length)
                    MovimientosObject.variables[nombreTemp[0][nombreTemp[1]][nombreTemp[2]]] = e ? timeToDateFill(new Date(e).getTime()) : e;
                }}
              />
            </Form.Group>
          </Grid.Col>)
      case "Any":
        switch (nombre) {
          case "cuenta_espejo":
            if (gpsTipoColocacion.value === 7) {
              let colsTemp = [];
              colsTemp.push(getForm("String", 400, "cuenta_espejo.url", "Url (Cuenta espejo)"));
              colsTemp.push(getForm("String", 200, "cuenta_espejo.usuario", "Usuario (Cuenta espejo)"));
              colsTemp.push(getForm("String", 200, "cuenta_espejo.password", "Password (Cuenta espejo)"));
              return colsTemp;
            } else {
              return null;
            }
          default:
            break;
        }
        break;
      case "Boolean":
        return (
          <Grid.Col md={4}>
            <Form.Group label={etiqueta}>
              {idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) ? (
                <>
                  {/* Switch para GPS por Contenedor */}
                  <Form.Switch
                    name={nombre}
                    checked={!variablesObj[nombre]}
                    label="GPS por Contenedor/caja"
                    onChange={(e) => {
                      const nombreTemp = nombre.split(".");
                      variablesObjTemp[nombre] = !e.target.checked;
                      setVariablesObj(variablesObjTemp);
                      if (1 === nombreTemp.length)
                        MovimientosObject.variables[nombreTemp[0]] = !e.target.checked;
                      if (2 === nombreTemp.length)
                        MovimientosObject.variables[nombreTemp[0]][nombreTemp[1]] = !e.target.checked;
                      if (3 === nombreTemp.length)
                        MovimientosObject.variables[nombreTemp[0][nombreTemp[1]][nombreTemp[2]]] = !e.target.checked;
                    }}
                  />
                  {/* Switch para GPS por Full */}
                  <br />
                  <Form.Switch
                    name={nombre}
                    checked={variablesObj[nombre]}
                    label="GPS por Full"
                    onChange={(e) => {
                      const nombreTemp = nombre.split(".");
                      variablesObjTemp[nombre] = e.target.checked;
                      setVariablesObj(variablesObjTemp);
                      if (1 === nombreTemp.length)
                        MovimientosObject.variables[nombreTemp[0]] = e.target.checked;
                      if (2 === nombreTemp.length)
                        MovimientosObject.variables[nombreTemp[0]][nombreTemp[1]] = e.target.checked;
                      if (3 === nombreTemp.length)
                        MovimientosObject.variables[nombreTemp[0][nombreTemp[1]][nombreTemp[2]]] = e.target.checked;
                    }}
                  />
                </>
              ) : (
                // Switch original para Full y Sencillo
                <Form.Switch
                  name={nombre}
                  checked={variablesObj[nombre]}
                  label={variablesObj[nombre] ? "Full" : "Sencillo"}
                  onChange={(e) => {
                    const nombreTemp = nombre.split(".");
                    variablesObjTemp[nombre] = e.target.checked;
                    setVariablesObj(variablesObjTemp);
                    if (1 === nombreTemp.length)
                      MovimientosObject.variables[nombreTemp[0]] = e.target.checked;
                    if (2 === nombreTemp.length)
                      MovimientosObject.variables[nombreTemp[0]][nombreTemp[1]] = e.target.checked;
                    if (3 === nombreTemp.length)
                      MovimientosObject.variables[nombreTemp[0][nombreTemp[1]][nombreTemp[2]]] = e.target.checked;
                  }}
                />
              )}
            </Form.Group>
          </Grid.Col>

        )
      default:
        break;
    }
  }

  const getNoPo = () => {
    let noPoCols = [];
    for (let i = 0; i < noPo; i++) {
      noPoCols.push(
        <Grid.Col md={4} key={i} >
          <Form.Group label={
            <div>
              {"OP(" + (i + 1) + ")"}
              <label className="font-weight-bold text-danger">*</label>
            </div>}>
            {" "}
            <Form.Input
              name={"po" + i}
              type="text"
              value={po[i] ? po[i] : ""}
              onChange={(e) => {
                let poTemp = [...po];
                const value = idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) 
                  ? e.target.value.toUpperCase() 
                  : e.target.value;
                poTemp[i] = value;
                setPo(poTemp);
              }}
              style={idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) 
                ? { textTransform: "uppercase" } 
                : {}}
            />
          </Form.Group>{" "}
        </Grid.Col>
      );
    }
    return noPoCols;
  }
  const getNoContenedores = () => {
    let noCotenedorCols = [];
    for (let i = 0; i < noContenedores; i++) {
      noCotenedorCols.push(
        <Grid.Col md={4} key={i} >
          <Form.Group label={
            <div>
              {"Contenedor/Caja (" + (i + 1) + ")"}
              <label className="font-weight-bold text-danger">*</label>
            </div>}>
            {" "}
            <Form.Input
              name={"contenedor" + i}
              type="text"
              value={contenedor[i] ? contenedor[i] : ""}
              onChange={(e) => {
                let contenedorTemp = [...contenedor];
                contenedorTemp[i] = [4, 61, 1381, 1480].includes(idPlataforma.value) ? e.target.value.toUpperCase() : e.target.value;
                setContenedor(contenedorTemp);
                MovimientosObject.contenedor = contenedorTemp.filter(c => c && c.length).join(";");
              }}
              style={idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) 
                ? { textTransform: "uppercase" } 
                : {}}
            />
          </Form.Group>{" "}
        </Grid.Col>
      );
    }
    return noCotenedorCols;
  }
  const getNoReferenciaFacturacion = () => {
    if (![4, 61, 1381, 1480].includes(idPlataforma.value)) return null;
    let refCols = [];
    for (let i = 0; i < noContenedores; i++) {
      refCols.push(
        <Grid.Col md={4} key={"ref" + i}>
          <Form.Group label={
            <div>
              {"Referencia de Facturación (" + (i + 1) + ")"}
              {!isChecked && <label className="font-weight-bold text-danger">*</label>}
            </div>}>
            <Form.Input
              name={"referenciaFacturacion" + i}
              type="text"
              value={referenciaFacturacion[i] ? referenciaFacturacion[i] : ""}
              disabled={isChecked}
              style={{
                backgroundColor: isChecked ? "#e9ecef" : "white",
                textTransform: "uppercase"
              }}
              onChange={(e) => {
                let refTemp = [...referenciaFacturacion];
                refTemp[i] = e.target.value.toUpperCase();
                setReferenciaFacturacion(refTemp);
              }}
            />
            {i === 0 && (
              <Form.Switch
                name="refFacturacionNA"
                checked={isChecked}
                label="N/A"
                onChange={() => handleCheckboxChange()}
              />
            )}
          </Form.Group>
        </Grid.Col>
      );
    }
    refCols.push(
      <Grid.Col md={12} key="ref-msg">
        <Alert type="danger" hasExtraSpace>
          <label className="font-weight-bold text-danger">Favor de considerar que con este dato/número de referencia se emitirá su factura.</label>
        </Alert>
      </Grid.Col>
    );
    return refCols;
  }
  // Función para eliminar una solicitud
  const eliminarSolicitud = (solicitud) => {
    confirmAlert({
      title: 'Confirmar eliminación',
      message: `¿Está seguro de eliminar la solicitud ${solicitud.idSolicitud}? Esta acción no se puede deshacer.`,
      buttons: [
        {
          label: 'Sí, eliminar',
          onClick: async () => {
            try {
              await Axios.delete(`${api_raiz}solicitudes_cliente/${solicitud.idSolicitud}`);
              NotificationManager.success(
                `Solicitud ${solicitud.idSolicitud} eliminada correctamente`,
                "Eliminada"
              );
              getSolicitudes();
            } catch (error) {
              console.error("Error al eliminar solicitud:", error);
              NotificationManager.error(
                "Error al eliminar la solicitud. Inténtelo de nuevo.",
                "Error"
              );
            }
          }
        },
        {
          label: 'Cancelar',
          onClick: () => {}
        }
      ]
    });
  };

  const getSolicitudes = () => getfuntion("get", "", "", "solicitudes_cliente", "solicitudes_cliente");
  const setCliente = (c) => {
    MovimientosObject.clienteS = c;
    MovimientosObject.idCliente = null;
    setIdCliente({ value: "temparal", label: c.nombre });
  }//transportistaS
  const setTransportista = (t) => {
    MovimientosObject.transportistaS = t;
    MovimientosObject.idTransportista = null;
    setIdTransportista({ value: "temparal", label: t.nombre });
  }

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [showCargaMasiva, setShowCargaMasiva] = useState(false);

  const openNewForm = () => {
    setIsFormOpen(true)


  }

  const closeNewForm = () => {
    setIsFormOpen(false)
    reset()
    initializeData();
  }

  return (
    <>

      <Modal
        isOpen={isFormOpen}
        contentLabel="Example Modal"
        overlayClassName="movimientos-modal-overlay"
        className="movimientos-modal-content"
      >
        <div className="modal-content">
          <div className="modal-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <h4 className="modal-title"> </h4>
            <Button
              size="sm"
              color="danger"
              onClick={closeNewForm}
              style={{ borderRadius: "50%", width: "32px", height: "32px", padding: "0", display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              <Icon name="x" />
            </Button>
          </div>
          <div className="modal-body">
            <div>
              <div className="container bg-light mb-2" style={{ height: "100%" }}>
                {[4, 61, 1381, 1480].includes(idPlataforma.value) && <h5>Tipo de Operación: {idOperacionTipo.label}</h5>}
                <Grid.Row>
                  <Grid.Col md={12} xl={12}>
                    <Grid.Row>
                      {![4, 61, 1381, 1480].includes(idPlataforma.value) && (
                      <Grid.Col md={4} lg={4}>
                        <Form.Group label="Plataforma">
                          <Select
                            value={idPlataforma}
                            onChange={changePlataformas}
                            options={plataformas}
                            isDisabled={plataformas.length === 1}
                            placeholder="Selecciona una plataforma"
                          />
                        </Form.Group>
                      </Grid.Col>
                      )}
                      {[4, 61, 1381, 1480].includes(idPlataforma.value) && (
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                              Tipo de colocación
                              <label className="font-weight-bold text-danger">*</label>
                            </div>}>
                            <Select
                              value={gpsTipoColocacion}
                              onChange={(e) => {
                                setGpsTipoColocacion(e);
                                const colocacionPlataforma = { 2: 1381, 1: 4, 5: 4, 7: 4, 3: 4, 4: 4 };
                                const idPltDestino = colocacionPlataforma[e.value];
                                if (idPltDestino) {
                                  const pltEncontrada = plataformas.find(p => p.value === idPltDestino);
                                  if (pltEncontrada) changePlataformas(pltEncontrada);
                                }
                              }}
                              options={gpsTipoColocaciones}
                            />
                          </Form.Group>
                        </Grid.Col>
                      )}
                      {/* Alertas según tipo de colocación */}
                      {[4, 61, 1381, 1480].includes(idPlataforma.value) && gpsTipoColocacion.value > 0 && gpsTipoColocacion.data && gpsTipoColocacion.data.id === 1 && (
                        <Grid.Col md={4}>
                          <Alert type="danger" hasExtraSpace>
                            <label className="text-danger">Aplica solo para carga &nbsp;</label>
                            <label className="font-weight-bold text-danger">contenerizada</label>
                          </Alert>
                        </Grid.Col>
                      )}
                      {[4, 61, 1381, 1480].includes(idPlataforma.value) && gpsTipoColocacion.value > 0 && gpsTipoColocacion.data && [3, 5].includes(gpsTipoColocacion.data.id) && (
                        <Grid.Col md={4}>
                          <Alert type="danger" hasExtraSpace>Se validará con personal de patios disponibilidad de este equipo especial en la localidad</Alert>
                        </Grid.Col>
                      )}
                      {/* Campos de desechable */}
                      {[4, 61, 1381, 1480].includes(idPlataforma.value) && gpsTipoColocacion.value > 0 && gpsTipoColocacion.data && gpsTipoColocacion.data.id === 2 && (
                      <>
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                              Tipo de Tecnología
                              <label className="font-weight-bold text-danger">*</label>
                            </div>}>
                            <Select
                              value={tecnologia}
                              onChange={changeTecnologia}
                              options={technologiaOpciones}
                              placeholder="4G Lite"
                            />
                          </Form.Group>
                        </Grid.Col>
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                              Lugar de colocación del GPS
                              <label className="font-weight-bold text-danger">*</label>
                            </div>}>
                            <Select
                              value={colocacionDesechable}
                              onChange={changeColocacionDesechable}
                              options={colocacionDesechableOpciones}
                              placeholder="Dentro de la caja"
                            />
                          </Form.Group>
                        </Grid.Col>
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                              Coloca GPS
                              <label className="font-weight-bold text-danger">*</label>
                            </div>}>
                            <Select
                              value={coloca}
                              onChange={changeColoca}
                              options={colocaOpciones}
                              placeholder="Coloca Sky"
                            />
                          </Form.Group>
                        </Grid.Col>
                        {coloca && coloca.value === 'Coloca cliente' && (
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                              OV
                              <label className="font-weight-bold text-danger">*</label>
                            </div>}>
                            <Form.Input 
                              value={ov} 
                              type="text"
                              onChange={(e) => {
                                if (e.target.value.length <= 20) {
                                  setOv(e.target.value.toUpperCase());
                                }
                              }}
                              maxLength="20"
                              style={{ textTransform: "uppercase" }}
                            />
                          </Form.Group>
                        </Grid.Col>
                        )}
                      </>
                      )}
                      <Grid.Col md={4}>
                        <Form.Group label={
                          <div>
                            Cliente
                            <label className="font-weight-bold text-danger">*</label>
                          </div>}>
                          <Grid.Row>
                            <Grid.Col>
                              <Select
                                value={idCliente}
                                onChange={changeCliente}
                                options={clientes}
                                isLoading={
                                  clientes.length === 0 ? true : false
                                }
                              />
                              {idCliente.value > 0 ? (
                                <p>{idCliente.data.domicilio}</p>
                              ) : null}
                            </Grid.Col>
                            {idPlataforma.value > 0 &&
                              (isEnable("actualizarCliente") ||
                                isEnable("agregarCliente")) ? (
                              <Grid.Col md={2} lg={2}>
                                {isEnable("agregarCliente") ? (
                                  <span className="float-right">
                                    <ModalLay
                                      tamanio="85%"
                                      title={"Nuevo"}
                                      name={
                                        <span
                                          className="fa fa-plus ml-2"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title={
                                            "Nuevo cliente(Antes de crear valida que no exista)"
                                          }
                                        ></span>
                                      }
                                      formulario={Cliente}
                                      datosForm={{
                                        accion: "nuevo",
                                        elementos: idCliente.data,
                                        setCliente: setCliente
                                      }}
                                    />
                                  </span>
                                ) : null}
                                {false && isEnable("actualizarCliente") ? (
                                  <span className="float-right">
                                    {idCliente.value > 0 ? (
                                      <ModalLay
                                        tamanio="85%"
                                        title="Modificar"
                                        name={
                                          <span
                                            className="fa fa-edit"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title={
                                              "Modificar (" +
                                              idCliente.label +
                                              ")"
                                            }
                                          ></span>
                                        }
                                        formulario={Cliente}
                                        datosForm={{
                                          accion: "modificar",
                                          elementos: idCliente.data,
                                          setCliente: setCliente
                                        }}
                                      />
                                    ) : null}
                                  </span>
                                ) : null}
                              </Grid.Col>
                            ) : null}
                          </Grid.Row>
                        </Form.Group>
                      </Grid.Col>
                      {[4, 61, 1381, 1480].includes(idPlataforma.value) && (
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                              Razón social a facturar
                              <label className="font-weight-bold text-danger">*</label>
                            </div>}>
                            <Form.Input
                              name="razonSocialFacturar"
                              type="text"
                              value={razonSocialFacturar}
                              onChange={(e) => {
                                setRazonSocialFacturar(e.target.value.toUpperCase());
                                MovimientosObject.razonSocialFacturar = e.target.value.toUpperCase();
                              }}
                              style={{ textTransform: "uppercase" }}
                              placeholder="Ej: EMPRESA S.A. DE C.V."
                            />
                          </Form.Group>
                        </Grid.Col>
                      )}
                      {false &&
                        <Grid.Col md={4}>
                          <Form.Group label="Cliente Final.">
                            <Select
                              value={idClienteNaviero}
                              onChange={changeClienteNaviero}
                              options={clientesNavieros}
                              isLoading={
                                clientesNavieros.length === 0
                                  ? true
                                  : false
                              }
                            />
                          </Form.Group>
                        </Grid.Col>}
                        { [4, 61, 1381, 1480].includes(idPlataforma.value) ?
                        <Grid.Col md={4}>   
                          <Form.Group label="Correo Notificaciones">
                            {idCliente.value > 0 && idCliente.data ? (
                              <ModalLay
                                tamanio={"900px"}
                                title="Gestión de Cliente"
                                name={
                                  <span
                                    className="fa fa-envelope ml-2"
                                    style={{ fontSize: "300%", cursor: "pointer" }}
                                    onClick={() => obtenerContactos()}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Notificación"
                                  ></span>
                                }
                                hiddenModal={hiddenModals}
                                Fclose={() => setHiddenModals(false)}
                                formulario={ClienteForm}
                                datosForm={{
                                  accion: "modificar",
                                  elementos: idCliente.data,
                                  stor: {privilegios_object: privilegios_object},
                                  plataforma: idPlataforma.data,
                                }}
                              />
                            ) : (
                              <span
                                className="fa fa-envelope ml-2"
                                style={{ 
                                  fontSize: "300%",
                                  opacity: 0.5,
                                  cursor: "not-allowed"
                                }}
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Selecciona un cliente primero"
                              ></span>
                            )}
                          </Form.Group>
                        </Grid.Col>
                        : null}
                      <Grid.Col md={4}>
                        <Form.Group label={
                          <div>
                            Tipo de Movimiento
                            <label className="font-weight-bold text-danger">*</label>
                          </div>}>
                          <Select
                            value={idMovimientoTipo}
                            onChange={changeMovimientoTipo}
                            options={movimientosTipo}
                            isLoading={
                              movimientosTipo.length === 0 ? true : false
                            }
                          />
                        </Form.Group>
                      </Grid.Col>
                      {idPlataforma.value && ![4, 61, 1381, 1480].includes(idPlataforma.value) &&
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                              Operación Tipo
                              <label className="font-weight-bold text-danger">*</label>
                            </div>}>
                            <Select
                              value={idOperacionTipo}
                              onChange={changeOperacionTipo}
                              options={operacionTipos}
                              isLoading={
                                operacionTipos.length === 0 ? true : false
                              }
                            />
                          </Form.Group>
                        </Grid.Col>
                      }
                      {[270].includes(idMovimientoTipo.value) ?
                        <Grid.Col md={4}>
                          <Grid.Row>
                            <div className="row">
                              <div className="col">
                                <label className="font-weight-bold">Origen(Consolidación)</label>
                                <label className="font-weight-bold text-danger">*</label>
                              </div>
                              <div className="col">
                                {!hiddenModals ?
                                  <ModalLay
                                    tamanio="85%"
                                    title={"Nuevo"}
                                    name={
                                      <span>
                                        <span
                                          className="fa fa-plus ml-2 btn"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title={
                                            "Agregar origen"
                                          }
                                        ></span>
                                      </span>
                                    }
                                    formulario={EntregasNavierasForm}
                                    datosForm={{
                                      entrega: null,
                                      movimiento: currentMovimiento,
                                      idPlataforma: idPlataforma,
                                      setEntregasAMov: setEntregasAMov,
                                      carga: true,
                                      setHiddenModals,
                                    }}
                                  />
                                  : null}
                              </div>
                            </div>
                            {
                              entregasCarga.map((e, index) =>
                                <Grid.Col key={e} md={12} >
                                  <Form.Group label={
                                    <div className="row">
                                      <div className="col-3 p-0">
                                        <div className="row">
                                          <div className="col-6">
                                            <div className="row">
                                              <div className="col-12 p-0" hidden={index < 1}>
                                                <i className="fa fa-caret-up btn" style={{ "font-size": "16px" }}
                                                  data-toggle="tooltip"
                                                  data-placement="top"
                                                  title={"Estableser orden " + (index + 1)}
                                                  onClick={() => {
                                                    let entregasCargaTemp = [...entregasCarga];
                                                    let entregasDesCargaTemp = [...entregasDesCarga];
                                                    const entregaTemp = entregasCargaTemp[index - 1];
                                                    entregasCargaTemp[index - 1] = e;
                                                    entregasCargaTemp[index] = entregaTemp;
                                                    const entregasOrdenadas = reordenarEntregas([...entregasCargaTemp], [...entregasDesCargaTemp]);
                                                    entregasCargaTemp = entregasOrdenadas.carga;
                                                    entregasDesCargaTemp = entregasOrdenadas.descarga;
                                                    setEntregasCarga(entregasCargaTemp);
                                                    setEntregasDesCarga(entregasDesCargaTemp);
                                                  }}></i>
                                              </div>
                                              <div className="col-12 p-0" hidden={index >= entregasCarga.length - 1}>
                                                <i className="fa fa-caret-down btn" style={{ "font-size": "16px" }}
                                                  data-toggle="tooltip"
                                                  data-placement="top"
                                                  title={"Estableser orden " + (index + 2)}
                                                  onClick={() => {
                                                    let entregasCargaTemp = [...entregasCarga];
                                                    let entregasDesCargaTemp = [...entregasDesCarga];
                                                    const entregaTemp = entregasCargaTemp[index + 1];
                                                    entregasCargaTemp[index + 1] = e;
                                                    entregasCargaTemp[index] = entregaTemp;
                                                    const entregasOrdenadas = reordenarEntregas([...entregasCargaTemp], [...entregasDesCargaTemp]);
                                                    entregasCargaTemp = entregasOrdenadas.carga;
                                                    entregasDesCargaTemp = entregasOrdenadas.descarga;
                                                    setEntregasCarga(entregasCargaTemp);
                                                    setEntregasDesCarga(entregasDesCargaTemp);
                                                  }}></i>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-6">{e.orden}</div>
                                        </div>
                                      </div>
                                      <div className="col-1 p-3">
                                        {!hiddenModals ?
                                          <ModalLay
                                            tamanio="85%"
                                            title="Modificar"
                                            name={
                                              <span
                                                className="fa fa-edit btn"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title={
                                                  "Modificar (" +
                                                  e.destino +
                                                  ")"
                                                }
                                              ></span>
                                            }
                                            formulario={EntregasNavierasForm}
                                            datosForm={{
                                              entrega: e,
                                              movimiento: currentMovimiento,
                                              idPlataforma: idPlataforma,
                                              setEntregasAMov: setEntregasAMov,
                                              carga: true,
                                              setHiddenModals,
                                            }}
                                          />
                                          : null}
                                      </div>
                                      <div className="col p-0">{e.destino}</div>
                                    </div>}>
                                  </Form.Group>
                                </Grid.Col>
                              )
                            }
                          </Grid.Row>
                        </Grid.Col>
                        : null}
                      {[270].includes(idMovimientoTipo.value) ?
                        <Grid.Col md={4}>
                          <Grid.Row>
                            <div className="row">
                              <div className="col">
                                <label className="font-weight-bold">Destino(Desconsolidación)</label>
                                <label className="font-weight-bold text-danger">*</label>
                              </div>
                              <div className="col">
                                {!hiddenModals ?
                                  <ModalLay
                                    tamanio="85%"
                                    title={"Nuevo"}
                                    name={
                                      <span>
                                        <span
                                          className="fa fa-plus ml-2"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title={
                                            "Agregar destino"
                                          }
                                        ></span>
                                      </span>
                                    }
                                    formulario={EntregasNavierasForm}
                                    datosForm={{
                                      entrega: null,
                                      movimiento: currentMovimiento,
                                      idPlataforma: idPlataforma,
                                      setEntregasAMov: setEntregasAMov,
                                      carga: false,
                                      setHiddenModals,
                                    }}
                                  />
                                  : null}
                              </div>
                            </div>
                            {
                              entregasDesCarga.map((e, index) =>
                                <Grid.Col md={12}>
                                  <Form.Group label={
                                    <div className="row">
                                      <div className="col-3 p-0">
                                        <div className="row">
                                          <div className="col-6">
                                            <div className="row">
                                              <div className="col-12" hidden={index < 1}>
                                                <i className="fa fa-caret-up btn" style={{ "font-size": "16px" }}
                                                  data-toggle="tooltip"
                                                  data-placement="top"
                                                  title={"Estableser orden " + (index + 1)}
                                                  onClick={() => {
                                                    let entregasCargaTemp = [...entregasCarga];
                                                    let entregasDesCargaTemp = [...entregasDesCarga];
                                                    const entregaTemp = entregasDesCargaTemp[index - 1];
                                                    entregasDesCargaTemp[index - 1] = e;
                                                    entregasDesCargaTemp[index] = entregaTemp;
                                                    const entregasOrdenadas = reordenarEntregas([...entregasCargaTemp], [...entregasDesCargaTemp]);
                                                    entregasCargaTemp = entregasOrdenadas.carga;
                                                    entregasDesCargaTemp = entregasOrdenadas.descarga;
                                                    setEntregasCarga(entregasCargaTemp);
                                                    setEntregasDesCarga(entregasDesCargaTemp);
                                                  }}></i>
                                              </div>
                                              <div className="col-12" hidden={index >= entregasDesCarga.length - 1}>
                                                <i className="fa fa-caret-down btn" style={{ "font-size": "16px" }}
                                                  data-toggle="tooltip"
                                                  data-placement="top"
                                                  title={"Estableser orden " + (index + 2)}
                                                  onClick={() => {
                                                    let entregasCargaTemp = [...entregasCarga];
                                                    let entregasDesCargaTemp = [...entregasDesCarga];
                                                    const entregaTemp = entregasDesCargaTemp[index + 1];
                                                    entregasDesCargaTemp[index + 1] = e;
                                                    entregasDesCargaTemp[index] = entregaTemp;
                                                    const entregasOrdenadas = reordenarEntregas([...entregasCargaTemp], [...entregasDesCargaTemp]);
                                                    entregasCargaTemp = entregasOrdenadas.carga;
                                                    entregasDesCargaTemp = entregasOrdenadas.descarga;
                                                    setEntregasCarga(entregasCargaTemp);
                                                    setEntregasDesCarga(entregasDesCargaTemp);
                                                  }}></i>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-6">{e.orden}</div>
                                        </div>
                                      </div>
                                      <div className="col-1 p-0">
                                        {!hiddenModals ?
                                          <ModalLay
                                            tamanio="85%"
                                            title="Modificar"
                                            name={
                                              <span
                                                className="fa fa-edit"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title={
                                                  "Modificar (" +
                                                  e.destino +
                                                  ")"
                                                }
                                              ></span>
                                            }
                                            formulario={EntregasNavierasForm}
                                            datosForm={{
                                              entrega: e,
                                              movimiento: currentMovimiento,
                                              idPlataforma: idPlataforma,
                                              setEntregasAMov: setEntregasAMov,
                                              carga: false,
                                              setHiddenModals,
                                            }}
                                          />
                                          : null}
                                      </div>
                                      <div className="col">{e.destino}</div>
                                    </div>
                                  }>
                                  </Form.Group>
                                </Grid.Col>
                              )
                            }
                          </Grid.Row>
                        </Grid.Col>
                        : null}
                      {![952].includes(idPlataforma.value) && idMovimientoTipo.value ?
                        <>
                        {[4, 61, 1381, 1480].includes(idPlataforma.value) && (
                          <Grid.Col md={4}>
                            <Form.Group label={
                              <div>
                                País
                                <label className="font-weight-bold text-danger">*</label>
                              </div>}>
                              <Select
                                value={paisSeleccionado}
                                onChange={(e) => {
                                  setPaisSeleccionado(e);
                                  setIdCorredor({ value: 0, label: "Selecciona un corredor" });
                                  MovimientosObject.idCorredor = {};
                                }}
                                options={[...new Set(corredores.map(c => c.pais))].sort().map(p => ({ value: p, label: p.toUpperCase() }))}
                              />
                            </Form.Group>
                          </Grid.Col>
                        )}
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                              Origen
                              <label className="font-weight-bold text-danger">*</label>
                            </div>}>
                            <Select
                              value={idCorredor}
                              onChange={changeCorredor}
                              options={[4, 61, 1381, 1480].includes(idPlataforma.value) 
                                ? corredores.filter(c => c.pais === paisSeleccionado.value)
                                : corredores}
                              isLoading={corredores.length === 0 ? true : false}
                            />
                          </Form.Group>
                        </Grid.Col>
                        </>
                        : null}
                      {![952].includes(idPlataforma.value) && idMovimientoTipo.value ?
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                              Destino                              <label className="font-weight-bold text-danger">*</label>
                            </div>
                          }>
                            {idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) ? (
                              <>
                                <Form.Input
                                  name="destino"
                                  type="text"
                                  value={destino}
                                  disabled
                                  style={{ backgroundColor: "#e9ecef" }}
                                  placeholder="Haz clic en el botón para ingresar dirección"
                                />
                                <ModalLay
                                  tamanio="700px"
                                  title="Destino"
                                  name={<Button pill size="sm" outline color="primary" className="mt-1"><Icon name="map-pin" /> {destino ? "Editar dirección" : "Ingresar dirección"}</Button>}
                                  formulario={ModalDestino}
                                  datosForm={{ estado, municipio, colonia, calle, numero, cp, setEstado, setMunicipio, setColonia, setCalle, setNumero, setCP }}
                                />
                              </>
                            ) : (
                              <Form.Input
                                name="destino"
                                type="text"
                                value={destino}
                                onChange={changeDestino}
                                maxlength="30"
                              />
                            )}
                          </Form.Group>
                        </Grid.Col>
                        : null}
                      {localidades.length && ![4, 61, 1381, 1480].includes(idPlataforma.value)?
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                             <div>
                              {<div>
                              {idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) ? 
                              <div>Localidad de colocación de equipo GPS <label className="font-weight-bold text-danger">*</label> </div> : <div>Localidad<label className="font-weight-bold text-danger">*</label> </div>}
                            </div>}
                            </div>
                            </div>}>
                            <Select
                              value={localidad}
                              onChange={changeLocalidad}
                              options={localidades}
                            />
                          </Form.Group>
                        </Grid.Col> : ""
                      }
                      {localidadesMT.length > 0 && [4, 61, 1381, 1480].includes(idPlataforma.value) ?
                        <>
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                              País (Localidad de colocación de GPS)
                              <label className="font-weight-bold text-danger">*</label>
                            </div>}>
                            <Select
                              value={paisLocalidad}
                              onChange={(e) => {
                                setPaisLocalidad(e);
                                setLocalidad({ value: 0, label: "Selecciona una localidad" });
                                MovimientosObject.idLocalidad = null;
                              }}
                              options={[...new Set(localidadesMT.map(l => l.pais))].sort().map(p => ({ value: p, label: p }))}
                            />
                          </Form.Group>
                        </Grid.Col>
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                              Localidad de colocación de equipo GPS <label className="font-weight-bold text-danger">*</label>
                            </div>}>
                            <Select
                              value={localidad}
                              onChange={changeLocalidad}
                              options={localidadesMT.filter(l => l.pais === paisLocalidad.value)}
                            />
                          </Form.Group>
                        </Grid.Col>
                        </>
                        : ""
                      }

                      <Grid.Col md={4}>
                        <Form.Group label={
                          <div>
                            Transportistas
                            <label className="font-weight-bold text-danger">*</label>
                          </div>}>
                          <Grid.Row>
                            <Grid.Col>
                              <Select
                                value={idTransportista}
                                onChange={changeTransportista}
                                options={transportistas}
                                isLoading={
                                  transportistas.length === 0 ? true : false
                                }
                              />
                            </Grid.Col>
                            {idPlataforma.value > 0 &&
                              (isEnable("actualizarTransportista") ||
                                isEnable("agregarTransportista")) ? (
                              <Grid.Col md={2} lg={2}>
                                {isEnable("agregarTransportista") ? (
                                  <span className="float-right">
                                    <ModalLay
                                      tamanio="85%"
                                      title={"Nuevo"}
                                      name={
                                        <span
                                          className="fa fa-plus ml-2"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title={
                                            "Nuevo Transportista(Antes de crear  valida que no exista)"
                                          }
                                        ></span>
                                      }
                                      formulario={Transportista}
                                      datosForm={{
                                        accion: "nuevo",
                                        elementos: idCliente.data,
                                        setTransportista: setTransportista
                                      }}
                                    />
                                  </span>
                                ) : null}
                                {false && isEnable("actualizarTransportista") ? (
                                  <span className="float-right">
                                    {idTransportista.value > 0 ? (
                                      <ModalLay
                                        tamanio="85%"
                                        title="Modificar"
                                        name={
                                          <span
                                            className="fa fa-edit"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title={
                                              "Modificar (" +
                                              idTransportista.label +
                                              ")"
                                            }
                                          ></span>
                                        }
                                        formulario={TransportistasForm}
                                        datosForm={{
                                          accion: "modificar",
                                          plataforma: idPlataforma.data,
                                          elementos: idTransportista.data,
                                          getfuntion: getfuntionTrans,
                                          stor: stor,
                                        }}
                                      />
                                    ) : null}
                                  </span>
                                ) : null}
                              </Grid.Col>
                            ) : null}
                          </Grid.Row>
                        </Form.Group>
                      </Grid.Col>
                      {idPlataforma.value > 0 ? (
                        [1, 3].includes(idPlataforma.data.plataformaTipo.id) ? (
                          <Grid.Col md={4}>
                            <Form.Group label={
                              <div>
                                Tipo de carga
                                <label className="font-weight-bold text-danger">*</label>
                              </div>}>
                              <Select
                                value={contenedorTipo}
                                onChange={changeContenedorTipo}
                                options={contenedoresTipo}
                                isLoading={
                                  contenedoresTipo.length === 0 ? true : false
                                }
                              />
                            </Form.Group>
                          </Grid.Col>
                        ) : null
                      ) : null}
                      {idPlataforma.value > 0 ? (
                        [1, 3].includes(idPlataforma.data.plataformaTipo.id) ? (
                          <Grid.Col md={4}>
                            <Form.Group label={
                              <div>
                                Tamaño
                                <label className="font-weight-bold text-danger">*</label>
                              </div>}>
                              <Select
                                value={contenedorSize}
                                onChange={changeContenedorSize}
                                options={remolquesTipo}
                              />
                            </Form.Group>
                          </Grid.Col>
                        ) : null
                      ) : null}
                      <Grid.Col md={4}>
                        <Form.Group label={
                          <div>
                            Cita programada (Cliente)
                            <label className="font-weight-bold text-danger">*</label>
                          </div>}>
                          <DateTimePicker
                            format="y-MM-dd h:mm:ss a"
                            value={citaProgramada}
                            onChange={onChangeDate}
                          />
                        </Form.Group>
                      </Grid.Col>
                      {idPlataforma.value && ![1315].includes(idPlataforma.value) && ![4, 61, 1381, 1480].includes(idPlataforma.value) ?
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                              Cita programada (Terminal) <label className="font-weight-bold text-danger">*</label>
                            </div>}>
                            <DateTimePicker
                              format="y-MM-dd h:mm:ss a"
                              value={citaProgramadaTerminal}
                              onChange={onChangeCitaProgramadaTerminal}
                            />
                          </Form.Group>
                        </Grid.Col>
                      : null}
                      {idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) ?
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                              Cita para colocación de GPS <label className="font-weight-bold text-danger">*</label>
                            </div>}>
                            <DateTimePicker
                              format="y-MM-dd h:mm:ss a"
                              value={citaColocacionGps}
                              onChange={onChangeCitaColocacionGps}
                            />
                          </Form.Group>
                        </Grid.Col>
                      : null}
                      {idPlataforma.value > 0 && ![4, 61, 1381, 1480].includes(idPlataforma.value) && (
                        <Grid.Col md={4}>
                          <Form.Group label={
                            <div>
                              Tipo de colocación
                              <label className="font-weight-bold text-danger">*</label>
                            </div>}>
                            <Select
                              value={gpsTipoColocacion}
                              onChange={(e) => setGpsTipoColocacion(e)}
                              options={gpsTipoColocaciones}
                            />
                          </Form.Group>
                        </Grid.Col>
                      )}
                      {/* Datos de Unidad y Operador */}
                      {idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) &&
                       (gpsTipoColocacion.value === 7 || (coloca && coloca.value === 'Coloca cliente')) ? (
                        !nuevo && currentMovimiento.idMovimiento ? (
                          <Grid.Col md={4}>
                            <Form.Group label={
                              <div>
                                Datos de Unidad y Operador
                              </div>}>
                              <ModalLay
                                tamanio="900px"
                                title="Datos de Unidad y Operador"
                                name={
                                  <Button size="sm" color="info" className="w-100">
                                    <Icon name="edit" /> Editar Datos de Unidad / Operador
                                  </Button>
                                }
                                formulario={ModalMovimientoPatio}
                                datosForm={{ idMovimiento: currentMovimiento.idMovimiento, remolquesTipo }}
                              />
                            </Form.Group>
                          </Grid.Col>
                        ) : nuevo ? (
                          <Grid.Col md={12}>
                            <center><h3>DATOS DE LA UNIDAD</h3></center>
                            <div className="row">
                              <div className="col col-12 col-sm-12 col-md-4">
                                <Form.Group label={<div>Modelo Tracto<label className="font-weight-bold text-danger">*</label></div>}>
                                  <Form.Input value={modelot} onChange={(e) => setModelot(e.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Ingrese modelo del tracto" />
                                </Form.Group>
                              </div>
                              <div className="col col-12 col-sm-12 col-md-4">
                                <Form.Group label={<div>Marca Tractor<label className="font-weight-bold text-danger">*</label></div>}>
                                  <Form.Input value={marcat} onChange={(e) => setMarcat(e.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Ingrese marca del tractor" />
                                </Form.Group>
                              </div>
                              <div className="col col-12 col-sm-12 col-md-4">
                                <Form.Group label={<div>Color Tractor<label className="font-weight-bold text-danger">*</label></div>}>
                                  <Form.Input value={colort} onChange={(e) => setColort(e.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Ingrese color del tractor" />
                                </Form.Group>
                              </div>
                              <div className="col col-12 col-sm-12 col-md-4">
                                <Form.Group label={<div>Placa Tractor<label className="font-weight-bold text-danger">*</label></div>}>
                                  <Form.Input value={placat} onChange={(e) => setPlacat(e.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Ingrese placa del tractor" />
                                </Form.Group>
                              </div>
                              <div className="col col-12 col-sm-12 col-md-4">
                                <Form.Group label={<div>Tipo plataforma<label className="font-weight-bold text-danger">*</label></div>}>
                                  <Select value={contenedorSize} onChange={changeContenedorSize} options={remolquesTipo} placeholder="Seleccione tipo de plataforma" />
                                </Form.Group>
                              </div>
                              <div className="col col-12 col-sm-12 col-md-4">
                                <Form.Group label={<div>Económico (Tracto)<label className="font-weight-bold text-danger">*</label></div>}>
                                  <Form.Input value={economicot} onChange={(e) => setEconomicot(e.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Ingrese número económico del tracto" />
                                </Form.Group>
                              </div>
                              <div className="col col-12 col-sm-12 col-md-4">
                                <Form.Group label={<div>Placa Remolque<label className="font-weight-bold text-danger">*</label></div>}>
                                  <Form.Input value={placar} onChange={(e) => setPlacar(e.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Ingrese placa del remolque" />
                                </Form.Group>
                              </div>
                              <div className="col col-12 col-sm-12 col-md-4">
                                <Form.Group label={<div>Económico (Remolque)<label className="font-weight-bold text-danger">*</label></div>}>
                                  <Form.Input value={economicor} onChange={(e) => setEconomicor(e.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Ingrese número económico del remolque" />
                                </Form.Group>
                              </div>
                              <div className="col col-12 col-sm-12 col-md-4">
                                <Form.Group label="Observaciones">
                                  <Form.Input value={observaciones} onChange={(e) => setObservaciones(e.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Observaciones adicionales" />
                                </Form.Group>
                              </div>
                            </div>
                            <center><h3>OPERADOR</h3></center>
                            <div className="row">
                              <div className="col col-12 col-sm-12 col-md-4">
                                <Form.Group label={<div>Nombre Operador<label className="font-weight-bold text-danger">*</label></div>}>
                                  <Form.Input value={nombreOperador} onChange={(e) => setNombreOperador(e.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Ingrese nombre completo del operador" />
                                </Form.Group>
                              </div>
                              <div className="col col-12 col-sm-12 col-md-4">
                                <Form.Group label={<div>Medio Contacto<label className="font-weight-bold text-danger">*</label></div>}>
                                  <Form.Input value={medioContacto} onChange={(e) => setMedioContacto(e.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Teléfono o correo del operador" />
                                </Form.Group>
                              </div>
                              <div className="col col-12 col-sm-12 col-md-4">
                                <Form.Group label="Licencia">
                                  <Form.Input value={licencia} onChange={(e) => setLicencia(e.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Número de licencia" />
                                </Form.Group>
                              </div>
                            </div>
                          </Grid.Col>
                        ) : null
                      ) : null}
                      <Grid.Col md={4}>
                        <Form.Group label={[952].includes(idPlataforma.value) ? "No Referencia" : "Booking"}
                        >
                          <Form.Input name="booking" type="text" value={booking}
                            onChange={(e) => {
                              const value = idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) 
                                ? e.target.value.toUpperCase() 
                                : e.target.value;
                              setBooking(value);
                              MovimientosObject.booking = value;
                            }}
                            style={idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) 
                              ? { textTransform: "uppercase" } 
                              : {}}
                            placeholder={idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) 
                              ? "Ej: BKG123456" 
                              : ""}
                          />
                        </Form.Group>
                      </Grid.Col>
                      {idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) ? (
                        <>
                          <Grid.Col md={4}>
                            <Form.Group label={
                              <div>
                                Contacto para monitoreo
                                <label className="font-weight-bold text-danger">*</label>
                              </div>}>
                              <Form.Input 
                                name="contactoMonitoreo1" 
                                type="text" 
                                value={contactoMonitoreo1}
                                onChange={(e) => {
                                  setContactoMonitoreo1(e.target.value.toUpperCase());
                                  MovimientosObject.contactoMonitoreo1 = e.target.value.toUpperCase();
                                }}
                                style={{ textTransform: "uppercase" }}
                                placeholder="Ej: JUAN PEREZ - 3312345678"
                              />
                            </Form.Group>
                          </Grid.Col>
                          <Grid.Col md={4}>
                            <Form.Group label={
                              <div>
                                Contacto para monitoreo 2
                                <label className="font-weight-bold text-danger">*</label>
                              </div>}>
                              <Form.Input 
                                name="contactoMonitoreo2" 
                                type="text" 
                                value={contactoMonitoreo2}
                                onChange={(e) => {
                                  setContactoMonitoreo2(e.target.value.toUpperCase());
                                  MovimientosObject.contactoMonitoreo2 = e.target.value.toUpperCase();
                                }}
                                style={{ textTransform: "uppercase" }}
                                placeholder="Ej: MARIA LOPEZ - 3398765432"
                              />
                            </Form.Group>
                          </Grid.Col>
                          <Grid.Col md={4}>
                            <Form.Group label={
                              <div>
                                Contacto para monitoreo 3
                              </div>}>
                              <Form.Input 
                                name="contactoMonitoreo3" 
                                type="text" 
                                value={contactoMonitoreo3}
                                onChange={(e) => {
                                  setContactoMonitoreo3(e.target.value.toUpperCase());
                                  MovimientosObject.contactoMonitoreo3 = e.target.value.toUpperCase();
                                }}
                                style={{ textTransform: "uppercase" }}
                                placeholder="Ej: PEDRO GOMEZ - 3387654321"
                              />
                            </Form.Group>
                          </Grid.Col>
                          <Grid.Col md={4}>
                            <Form.Group label={
                              <div>
                                Contacto de la línea para colocación
                                <label className="font-weight-bold text-danger">*</label>
                              </div>}>
                              <Form.Input 
                                name="contactoLineaColocacion1" 
                                type="text" 
                                value={contactoLineaColocacion1}
                                onChange={(e) => {
                                  setContactoLineaColocacion1(e.target.value.toUpperCase());
                                  MovimientosObject.contactoLineaColocacion1 = e.target.value.toUpperCase();
                                }}
                                style={{ textTransform: "uppercase" }}
                                placeholder="Ej: CARLOS RUIZ - 3376543210"
                              />
                            </Form.Group>
                          </Grid.Col>
                          <Grid.Col md={4}>
                            <Form.Group label={
                              <div>
                                Contacto de la línea para colocación 2
                                <label className="font-weight-bold text-danger">*</label>
                              </div>}>
                              <Form.Input 
                                name="contactoLineaColocacion2" 
                                type="text" 
                                value={contactoLineaColocacion2}
                                onChange={(e) => {
                                  setContactoLineaColocacion2(e.target.value.toUpperCase());
                                  MovimientosObject.contactoLineaColocacion2 = e.target.value.toUpperCase();
                                }}
                                style={{ textTransform: "uppercase" }}
                                placeholder="Ej: ANA MARTINEZ - 3365432109"
                              />
                            </Form.Group>
                          </Grid.Col>
                          <Grid.Col md={4}>
                            <Form.Group label={
                              <div>
                                Contacto de la línea para colocación 3
                              </div>}>
                              <Form.Input 
                                name="contactoLineaColocacion3" 
                                type="text" 
                                value={contactoLineaColocacion3}
                                onChange={(e) => {
                                  setContactoLineaColocacion3(e.target.value.toUpperCase());
                                  MovimientosObject.contactoLineaColocacion3 = e.target.value.toUpperCase();
                                }}
                                style={{ textTransform: "uppercase" }}
                                placeholder="Ej: LUIS SANCHEZ - 3354321098"
                              />
                            </Form.Group>
                          </Grid.Col>
                        </>
                      ) : null}
                      {idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value)
                        ? getVariablesFiltradas().map((v, inex) => getForm(v.tipo, v.longitud, v.nombre, v.etiqueta))
                        : variables.map((v, inex) => getForm(v.tipo, v.longitud, v.nombre, v.etiqueta))
                      }
                      <Grid.Col>
                        <Form.Group
                          label={
                            <Form.Label aside={nota.length + "/2000"}>
                              Nota
                            </Form.Label>
                          }
                        >
                          {" "}
                          <Form.Textarea
                            //value={nota}
                            name="nota"
                            onChange={changeNota}
                            placeholder="Nota del movimiento.."
                            rows={6}
                          >{nota}</Form.Textarea>{" "}
                        </Form.Group>{" "}
                      </Grid.Col>
                    </Grid.Row>
                    {idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) && (
                      <Grid.Row>
                        <Grid.Col md={12}>
                          <Form.Group label={
                            <div>
                              Modalidades de Transporte
                              <label className="font-weight-bold text-danger">*</label>
                            </div>
                          }>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
                              {modalidades.map((modalidad) => (
                              <div key={modalidad.id} className="checkbox-modalidad">
                                <Form.Checkbox
                                  label={`Transporte ${modalidad.name}`}
                                  checked={modalidadesSeleccionadas.some(m => m.id === modalidad.id)}
                                  onChange={() => handleModalidadChange(modalidad)}
                                />
                              </div>
                            ))}
                            </div>
                          </Form.Group>
                        </Grid.Col>
                      </Grid.Row>
                    )}
                    <hr />
                    <Grid.Row>
                      <Grid.Col md={12}>
                        <Form.Group label="¿Generear un movimiento por contenedor?">
                          <Form.Switch
                            name="unMovimientoPorContenedor"
                            checked={unMovimientoPorContenedor}
                            label={unMovimientoPorContenedor ?
                              "Se generara un movimiento por contenedor ingresado" :
                              "Solo se generara un movimiento"}
                            onChange={(e) => { setUnMovimientoPorContenedor(e.target.checked); }}
                          />
                        </Form.Group>
                      </Grid.Col>
                      {[952].includes(idPlataforma.value) &&
                        <Grid.Col md={12}>
                          <Form.Group label={
                            <div class="row">
                              <label for="noPo" class="col-2 col-form-label">No Op</label>
                              <div class="col-2">
                                <Form.Input name="noPo" type="number" value={noPo}
                                  onChange={(e) => {
                                    if (e.target.value > 0 && ([952].includes(idPlataforma.value) ? e.target.value <= 2 : e.target.value < 11)) {
                                      const newValue = parseInt(e.target.value);
                                      setNoPo(newValue);
                                      // Ajustar el array de po al nuevo tamaño
                                      const newPo = Array(newValue).fill('').map((_, i) => po[i] || '');
                                      setPo(newPo);
                                      if (unMovimientoPorContenedor) {
                                        setNoContenedores(newValue);
                                        const newContenedor = Array(newValue).fill('').map((_, i) => contenedor[i] || '');
                                        setContenedor(newContenedor);
                                      }
                                    }
                                  }}
                                />
                              </div>
                            </div>}
                          >
                            <Grid.Row>
                              {getNoPo()}
                            </Grid.Row>
                          </Form.Group>
                        </Grid.Col>
                      }
                      <Grid.Col md={12}>
                        <Form.Group label={
                          <div class="row">
                            <label for="NoCotenedores" class="col-2 col-form-label">No Contenedores</label>
                            <div class="col-2">
                              <Form.Input name="noContenedores" type="number" value={noContenedores}
                                onChange={(e) => {
                                  if (e.target.value > 0 && ([952].includes(idPlataforma.value) ? e.target.value <= 2 : e.target.value < 11)) {
                                    const newValue = parseInt(e.target.value);
                                    setNoContenedores(newValue);
                                    // Ajustar el array de contenedores al nuevo tamaño
                                    const newContenedor = Array(newValue).fill('').map((_, i) => contenedor[i] || '');
                                    setContenedor(newContenedor);
                                    // Ajustar el array de referencias de facturación
                                    if ([4, 61, 1381, 1480].includes(idPlataforma.value)) {
                                      const newRef = Array(newValue).fill('').map((_, i) => referenciaFacturacion[i] || '');
                                      setReferenciaFacturacion(newRef);
                                    }
                                    if (unMovimientoPorContenedor) {
                                      setNoPo(newValue);
                                      const newPo = Array(newValue).fill('').map((_, i) => po[i] || '');
                                      setPo(newPo);
                                    }
                                  }
                                }}
                              />
                            </div>
                          </div>}
                        >
                          <Grid.Row>
                            {getNoContenedores()}
                          </Grid.Row>
                          {[4, 61, 1381, 1480].includes(idPlataforma.value) && (
                            <Grid.Row>
                              {getNoReferenciaFacturacion()}
                            </Grid.Row>
                          )}
                        </Form.Group>
                      </Grid.Col>
                    </Grid.Row>
                  </Grid.Col>
                </Grid.Row>
                <div className="float-right">
                  {isEnable("actualizar") || isEnable("agregar") ? (<div></div>) : null}
                  <span class="badge">
                    <Button
                      target="_blank"
                      size="sm"
                      RootComponent="a"
                      color="danger"
                      disabled={!crudbutonEnable}
                      onClick={closeNewForm}
                    >
                      <span class="badge">
                        <Icon link={true} name="x" />
                        Cancelar
                      </span>
                    </Button>
                  </span>
                </div>
                <div className="float-right">
                  {isEnable("actualizar") || isEnable("agregar") ? (<div></div>) : null}
                  <span class="badge">
                    <Button
                      target="_blank"
                      size="sm"
                      RootComponent="a"
                      color="primary"
                      disabled={enableSave() || !crudbutonEnable}
                      onClick={guardarMovimiento}
                    >
                      <span class="badge">
                        <Icon link={true} name="save" />
                        Guardar
                      </span>
                    </Button>
                  </span>
                </div>
                {(() => {
                  const resultado = validarGuardado({
                    idPlataforma, idCliente, idMovimientoTipo, destino, idCorredor, localidad,
                    idTransportista, contenedorSize, contenedorTipo, contenedor, noContenedores,
                    idOperacionTipo, po, noPo, ejecutivo, citaProgramada, citaProgramadaTerminal,
                    citaColocacionGps, gpsTipoColocacion, tecnologia, estado, municipio, colonia, calle, numero, cp,
                    modelot, marcat, colort, placat, economicot, placar, economicor,
                    nombreOperador, medioContacto, coloca, colocacionDesechable, ov,
                    contactoMonitoreo1, contactoMonitoreo2, contactoLineaColocacion1, contactoLineaColocacion2,
                    razonSocialFacturar, referenciaFacturacion, isChecked, nuevo, modalidadesSeleccionadas,
                  });
                  return !resultado.habilitado && [4, 61, 1381, 1480].includes(idPlataforma.value) && (
                    <div className="float-right">
                      <Alert type="danger" hasExtraSpace>{resultado.mensaje}</Alert>
                    </div>
                  );
                })()}
                <br /><br /><br /><br />
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) && (
      <ModalCancelacionServicio
        isOpen={modalCancelacionOpen}
        onClose={() => {
          setModalCancelacionOpen(false);
          setServicioACancelar(null);
          setTieneGPS(false);
        }}
        servicio={servicioACancelar}
        tieneGPS={tieneGPS}
        onConfirmar={cancelarServicio}
        cargando={procesandoCancelacion}
      />
      )}
      {<LoadStore catalogos={["privilegios", "incidencias"]} />}
      <SiteWrapper>
        <Grid.Col sm={12} lg={12}>

          <div style={{ height: "90vh", "font-size": "smaller" }}>

            {/* <SplitterLayout vertical= {false} percentage= {true}  secondaryInitialSize= {45}> */}
            <div>

              <i className={(hiddenPanel ? "fa fa-reply" : "fa fa-share") + " " + (hiddenPanel ? "text-success" : "text-danger")}
                style={
                  {
                    'font-size': "24px",
                    'float': "right",
                    'position': 'sticky',
                    'top': '0%',
                    'z-index': '1',
                  }
                }
                onClick={() => {
                  for (let c of document.getElementsByClassName("layout-pane")) {
                    if (c.className && c.className === "layout-pane")
                      c.style.width = !hiddenPanel ? "0%" : "40%";
                  }
                  setHiddenPanel(!hiddenPanel);
                }}
              ></i>
              <div className="main-content-wrapper">
                <div className="solicitudes-toolbar">
                  <Button icon="save" type="submit" onClick={openNewForm}>Crear nueva solicitud</Button>
                  {JSON.parse(sessionStorage.getItem("perfil"))?.id === 2893 && (
                    <Button color="success" onClick={() => setShowCargaMasiva(true)}>
                      <Icon name="upload" className="mr-1" />
                      Carga Masiva
                    </Button>
                  )}
                </div>
                {/* Modal de Carga Masiva */}
                <Modal
                  isOpen={showCargaMasiva}
                  onRequestClose={() => setShowCargaMasiva(false)}
                  overlayClassName="movimientos-modal-overlay"
                  className="movimientos-modal-content"
                >
                  <div className="modal-content">
                    <div className="modal-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <h4 className="modal-title">Carga Masiva</h4>
                      <Button
                        size="sm"
                        color="danger"
                        onClick={() => setShowCargaMasiva(false)}
                        style={{ borderRadius: "50%", width: "32px", height: "32px", padding: "0", display: "flex", alignItems: "center", justifyContent: "center" }}
                      >
                        <Icon name="x" />
                      </Button>
                    </div>
                    <div className="modal-body">
                      <CargaMasivaSolicitudes
                        catalogos={{
                          clientes,
                          transportistas,
                          corredores,
                          localidades: localidadesMT.length > 0 ? localidadesMT : localidades,
                          movimientosTipo,
                          operacionTipos,
                          gpsTipoColocaciones,
                          remolquesTipo,
                          contenedoresTipo,
                          modalidades,
                        }}
                        plataformas={plataformas}
                        idPlataforma={idPlataforma.value}
                        onClose={() => setShowCargaMasiva(false)}
                        onSuccess={() => getSolicitudes()}
                      />
                    </div>
                  </div>
                </Modal>
                <div className="solicitudes-table-container">
                <TablePageable
                  titulo={<h3> Solicitudes estatus </h3>}
                  lista={solicitudes}
                  elementosPorPagina={10}
                  paginacion={true}
                  columnas={
                    [
                      {
                        columna: "idSolicitud",
                        label: "Id",
                        enClick: (e) => {
                          setIsFormOpen(true)
                          setCurrentMovimiento(e)
                        }, //enClickDisabled: (e)=> false,//e.idSolicitud === 303? false: true,
                        form: (e) => <i className="fa fa-edit" style={{ "font-size": "24px" }}><p style={{ fontSize: "16px" }}>{e.idSolicitud}</p></i>
                      },
                      { columna: "idMovimiento", label: "idMovimiento" },
                      { columna: "po", label: "Po", splitBy: ";" },
                      { columna: "contenedor", label: "Contenedor", splitBy: ";" },
                      { columna: "contenedorTipo", label: "Tipo contenedor" },
                      { columna: "contenedorSize", label: "Tamaño de Contenedor" },
                      { columna: "idOperacionTipo.nombre", label: "Tipo de operacion" },
                      { columna: "idMovimientoTipo.nombre", label: "Tipotipo de movimiento" },
                      { columna: "idTransportista.nombre", label: "Transportista" },
                      { columna: "idCliente.nombre", label: "Cliente" },
                      ...(idPlataforma.value && [4, 61, 1381, 1480].includes(idPlataforma.value) ? [{
                        columna: "idSolicitud",
                        label: "Cancelar Solicitud",
                        enClick: (e) => {
                          if (e.idMovimiento) {
                            consultarGPSMovimiento(e);
                          }
                        },
                        form: (e) => (
                          e.idMovimiento ? (
                            <Button 
                              pill 
                              size="sm" 
                              outline 
                              color="danger"
                              disabled={cargandoGPS || e.cancelado}
                              title={e.cancelado ? "Servicio cancelado" : "Cancelar servicio"}
                            >
                              {cargandoGPS ? <Icon name="loader" /> : <Icon name="x" />}
                            </Button>
                          ) : null
                        )
                      }] : []),
                    ]
                  }
                  id="idSolicitud"
                  //selected={(e) => setCurrentMovimiento(e) }
                  csvname="Solicitudes"
                  resaltarFuncion={(e) => {
                    if (e.cancelado) return true; // Servicios cancelados
                    if (!e.idMovimiento) return true; // Solicitudes sin movimiento
                    return false;
                  }}
                  resaltarColor={(e) => {
                    if (e.cancelado) return "rgba(128, 128, 128, 0.47)"; // Gris para cancelados
                    if (!e.idMovimiento) return "rgba(223, 58, 58, 0.47)"; // Rojo para sin movimiento
                    return "transparent";
                  }}
                />
                </div>
              </div>
            </div>

            {/* </SplitterLayout> */}
          </div>

        </Grid.Col>
      </SiteWrapper>
    </>
  );
}

function mapStateToProps(state) {
  return {
    privilegios_object: state.catalogos_reducer.privilegios_object,
    incidencias_object: state.catalogos_reducer.incidencias_object,
    localidades_object: state.catalogos_reducer.localidades_object,
  }
}
function mapDispachToProps(dispach) {
  return {
    incidencias_update: (elementos) => dispach(ACTIONS.elementos_incidencias_imput(elementos)),
    privilegios_update: (elementos) => dispach(ACTIONS.elementos_privilegios_imput(elementos)),
  }
}
export default connect(mapStateToProps, mapDispachToProps)(MovimientosNavierosClientePage);